var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-259"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M628.25,151.93a9.69,9.69,0,1,1-9.69-9.68A9.69,9.69,0,0,1,628.25,151.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.12,151.93a10.32,10.32,0,1,1-10.32-10.31A10.32,10.32,0,0,1,600.12,151.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 567.69,
    cy: 133.68,
    r: 10.95,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 563.2,
    cy: 105.61,
    r: 11.44,
    transform: "translate(90.28 429.18) rotate(-45)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 577.21,
    cy: 81.04,
    r: 11.82,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.14,
    cy: 71.33,
    r: 12.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 639.93,
    cy: 133.45,
    r: 9.36,
    transform: "translate(396.59 740.17) rotate(-79.92)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.62,105.3a8.68,8.68,0,1,1-8.68-8.69A8.68,8.68,0,0,1,653.62,105.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 630.5,
    cy: 80.72,
    r: 7.93,
    transform: "translate(450.07 690.22) rotate(-80.81)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.27,227.94a27.57,27.57,0,0,1,7.22,1.91l5.31-4.45,9.12,6.94-2.87,6.3a27.86,27.86,0,0,1,3.76,6.46l6.9.6,1.54,11.36-6.48,2.43a28.48,28.48,0,0,1-1.91,7.22l4.45,5.31-6.94,9.12-6.31-2.87a28.36,28.36,0,0,1-6.45,3.76l-.61,6.9-11.36,1.54L149.22,284a27.64,27.64,0,0,1-7.23-1.91l-5.31,4.45-9.12-6.94,2.88-6.3a28.25,28.25,0,0,1-3.77-6.46l-6.9-.6-1.54-11.36,6.49-2.43a27.67,27.67,0,0,1,1.91-7.22l-4.45-5.31,6.94-9.12,6.3,2.87a28.43,28.43,0,0,1,6.46-3.76l.61-6.9,11.35-1.54,2.43,6.49Zm-4.66,15.77a12.29,12.29,0,1,0,13.83,10.53A12.29,12.29,0,0,0,151.61,243.71Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.61,243.71a9,9,0,0,1,3-.16,12.19,12.19,0,0,1,7.47,3.48,12.39,12.39,0,0,1,3.08,4.9,12.59,12.59,0,0,1,.38,6.63A12.58,12.58,0,0,1,162,265a12.55,12.55,0,0,1-14.81,2,12.52,12.52,0,0,1-5.13-5.24,12.53,12.53,0,0,1-1.4-6.49,12.4,12.4,0,0,1,1.67-5.54,12.27,12.27,0,0,1,6.27-5.35,9.3,9.3,0,0,1,3-.65,27.07,27.07,0,0,0-2.88.91,12.32,12.32,0,0,0-5.94,5.33,12,12,0,0,0-.12,11.49,11.48,11.48,0,0,0,2,2.78,11.33,11.33,0,0,0,2.86,2.16,11.95,11.95,0,0,0,14-1.9,11.26,11.26,0,0,0,2.18-2.85,11.42,11.42,0,0,0,1.22-3.21,12.15,12.15,0,0,0-.31-6.31,11.91,11.91,0,0,0-2.87-4.73,12.25,12.25,0,0,0-7.15-3.56A29.23,29.23,0,0,0,151.61,243.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.27,227.94a2,2,0,0,1-.18-.4c-.12-.3-.27-.7-.48-1.22q-.66-1.68-1.87-4.83l.12.07-11.35,1.61.15-.16c-.17,2.09-.37,4.41-.57,6.9l0,.12-.11.05a27.61,27.61,0,0,0-6.39,3.76l-.11.08-.13-.06L129,231l.31-.08-6.92,9.14v-.35l4.46,5.3.12.14-.07.16a28,28,0,0,0-1.88,7.15l0,.18-.17.07-6.49,2.43.21-.33c.48,3.56,1,7.41,1.55,11.35l-.3-.28,6.9.6.2,0,.08.19a28,28,0,0,0,3.73,6.37l.12.16-.08.19-2.87,6.31-.11-.42,9.12,6.94h-.43l5.31-4.46.16-.13.2.08a27.51,27.51,0,0,0,7.12,1.88h0c.13.1-.29-.22.29.23h0v0l0,.05,0,.11.08.2.15.41.3.82.61,1.62c.41,1.08.81,2.16,1.21,3.24l-.38-.23L163,288.58l-.3.32c.21-2.33.41-4.62.61-6.9l0-.21.19-.08a27.87,27.87,0,0,0,6.38-3.71l.17-.13.18.09,6.31,2.87-.41.11c2.37-3.12,4.69-6.15,7-9.12v.41l-4.45-5.32-.12-.14.07-.18a27.57,27.57,0,0,0,1.9-7.14l0-.19.17-.06,6.49-2.41-.19.31c-.53-4-1-7.77-1.52-11.36l.25.23-6.9-.62-.15,0-.06-.14a28.21,28.21,0,0,0-3.71-6.41l-.09-.11.06-.13c1-2.28,2-4.34,2.89-6.29l.07.25c-3.53-2.7-6.53-5-9.09-7h.19l-5.33,4.41-.06,0-.06,0a28.43,28.43,0,0,0-5.36-1.66l-1.37-.26-.45-.09a2.64,2.64,0,0,1,.46,0c.3,0,.77.09,1.38.2a26.94,26.94,0,0,1,5.43,1.57l-.12,0,5.28-4.49.1-.08.1.08,9.15,6.9.13.1-.07.15-2.85,6.32,0-.24a28.69,28.69,0,0,1,3.82,6.5l-.21-.16,6.9.59.21,0,0,.22c.49,3.59,1,7.36,1.56,11.35l0,.23-.22.09-6.48,2.43.2-.25a28.42,28.42,0,0,1-1.92,7.31l-.05-.32,4.46,5.3.16.2-.16.21-6.93,9.12-.16.22-.24-.11-6.31-2.87.35,0a28.86,28.86,0,0,1-6.53,3.81l.21-.29q-.3,3.42-.6,6.9l0,.28-.27,0-11.36,1.55-.28,0-.1-.27c-.4-1.07-.8-2.15-1.21-3.23l-.61-1.63-.3-.81-.15-.41-.08-.21,0-.1,0-.05v0h0l.28.22h0a28.47,28.47,0,0,1-7.31-1.93l.36-.06-5.31,4.45-.22.18-.22-.17-9.12-6.94-.22-.17.12-.25c1-2.18,2-4.33,2.88-6.3l0,.35a28.45,28.45,0,0,1-3.81-6.54l.28.21-6.89-.62-.27,0,0-.26-1.53-11.36,0-.25.23-.09,6.49-2.41-.19.25a28.53,28.53,0,0,1,1.94-7.3l0,.3L122,240.08l-.15-.17.14-.18,7-9.1.12-.16.18.08,6.3,2.89-.24,0a28.24,28.24,0,0,1,6.52-3.77l-.13.17c.23-2.48.45-4.8.64-6.89v-.15l.14,0,11.37-1.47h.09l0,.08c.75,2.1,1.34,3.71,1.74,4.83l.44,1.26A4.14,4.14,0,0,1,156.27,227.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.72,305.3a40,40,0,0,1,10.21,2.7l7.51-6.29,12.89,9.81-4.06,8.92a39.46,39.46,0,0,1,5.32,9.12l9.76.86,2.17,16.06-9.17,3.43a39.23,39.23,0,0,1-2.7,10.21l6.3,7.51-9.82,12.9-8.91-4.07a39.32,39.32,0,0,1-9.13,5.32l-.86,9.76-16.06,2.18-3.42-9.17a40.22,40.22,0,0,1-10.22-2.7L87,388.14l-12.89-9.82,4.06-8.91a40,40,0,0,1-5.32-9.13l-9.75-.86-2.18-16.05,9.17-3.43a39.41,39.41,0,0,1,2.7-10.22l-6.29-7.5,9.81-12.9,8.91,4.06a40.26,40.26,0,0,1,9.13-5.32l.86-9.75,16.06-2.18,3.43,9.17Zm-6.6,22.3a17.38,17.38,0,1,0,19.57,14.89A17.39,17.39,0,0,0,108.12,327.6Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478,96.45a27.51,27.51,0,0,1,7,1.85L490.1,94l8.83,6.72-2.78,6.1a27.19,27.19,0,0,1,3.64,6.25l6.68.59,1.49,11L501.68,127a26.7,26.7,0,0,1-1.85,7l4.31,5.14L497.42,148l-6.1-2.78a27.19,27.19,0,0,1-6.25,3.64l-.59,6.68-11,1.49-2.35-6.28a27.08,27.08,0,0,1-7-1.84l-5.14,4.3-8.83-6.72,2.78-6.1a27,27,0,0,1-3.64-6.25l-6.68-.59-1.49-11,6.28-2.35a26.7,26.7,0,0,1,1.85-7L445,108l6.72-8.83,6.1,2.78A27.19,27.19,0,0,1,464,98.34l.59-6.68,11-1.49L478,96.45Zm-4.52,15.27a11.9,11.9,0,1,0,13.4,10.19A11.9,11.9,0,0,0,473.45,111.72Z",
    style: {
      fill: "#ebebeb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.62,319a32.22,32.22,0,0,1,8.11,2.14l6-5L234.92,324,231.7,331a31.9,31.9,0,0,1,4.22,7.25l7.75.68,1.72,12.75-7.28,2.72a31.4,31.4,0,0,1-2.14,8.11l5,6-7.79,10.23-7.08-3.22a31.62,31.62,0,0,1-7.24,4.22l-.68,7.74-12.75,1.73-2.72-7.28a31.4,31.4,0,0,1-8.11-2.14l-6,5L178.4,377l3.23-7.07a31.62,31.62,0,0,1-4.22-7.24l-7.74-.69-1.73-12.74,7.28-2.72a31.29,31.29,0,0,1,2.14-8.11l-5-6,7.79-10.24,7.08,3.23a31.66,31.66,0,0,1,7.24-4.23l.68-7.74,12.75-1.73,2.72,7.28Zm-5.23,17.7a13.8,13.8,0,1,0,15.53,11.82A13.8,13.8,0,0,0,205.39,336.72Z",
    style: {
      fill: "#f5f5f5",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-259"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.92,
    y: 125.49,
    width: 391.42,
    height: 197.9,
    rx: 10.52,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.82,323.39l.75-.05a10.39,10.39,0,0,0,2.19-.4A10.61,10.61,0,0,0,540,321.3a10.35,10.35,0,0,0,3.2-3.88,9.72,9.72,0,0,0,.91-2.91,20.68,20.68,0,0,0,.13-3.39c0-2.38,0-5,0-7.82,0-5.65,0-12.17,0-19.51,0-29.37,0-71.86-.09-124.36q0-9.84,0-20.15a35.09,35.09,0,0,0-.18-5.14,10.33,10.33,0,0,0-2.12-4.62,10.29,10.29,0,0,0-6.64-3.73,19.39,19.39,0,0,0-2.65-.1l-44.67,0-98.57,0-225.84,0a10.39,10.39,0,0,0-6.72,2.49,10.15,10.15,0,0,0-3.44,6.25,26.36,26.36,0,0,0-.13,3.68v98.26q0,28.33,0,55.62v20.28a10.5,10.5,0,0,0,1.7,6.2,10.33,10.33,0,0,0,5,4c2,.84,4.25.61,6.44.65h13.1l184.46.06,124.35.08,33.81,0,8.79,0c2,0,3,0,3,0l-3,0-8.79,0-33.81.05-124.35.09-184.46.05h-13.1c-1.1,0-2.18,0-3.3,0a9.9,9.9,0,0,1-3.31-.66,10.76,10.76,0,0,1-5.24-4.15,11.07,11.07,0,0,1-1.79-6.47v-75.9q0-28.34,0-57.63V138.17a28.08,28.08,0,0,1,.13-3.76,10.66,10.66,0,0,1,3.62-6.56,10.87,10.87,0,0,1,7.06-2.62l225.84,0,98.57,0h44.67a18.88,18.88,0,0,1,2.7.11,10.77,10.77,0,0,1,2.62.69,11,11,0,0,1,4.28,3.18,10.81,10.81,0,0,1,2.2,4.8,13.7,13.7,0,0,1,.18,2.62v2.59q0,10.31,0,20.15c0,52.5-.06,95-.08,124.36,0,7.34,0,13.86,0,19.51q0,4.24,0,7.82a19.93,19.93,0,0,1-.15,3.41,9.49,9.49,0,0,1-.92,2.93,10.37,10.37,0,0,1-3.25,3.9,10.66,10.66,0,0,1-3.3,1.63,11,11,0,0,1-2.21.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.11,160.67a44.22,44.22,0,0,1,4.65-5,46.15,46.15,0,0,1,5-4.66,44.92,44.92,0,0,1-4.65,5A45.39,45.39,0,0,1,505.11,160.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.83,160.72a46.29,46.29,0,0,1-5.07-4.7,43.69,43.69,0,0,1-4.7-5.08,47.06,47.06,0,0,1,5.07,4.71A46.29,46.29,0,0,1,514.83,160.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.12,155.59a26.72,26.72,0,0,0-.48-3,12.22,12.22,0,0,0-4.44-6.58,12,12,0,0,0-11.32-1.68,12.06,12.06,0,0,0-5.53,4.16,11.86,11.86,0,0,0,0,14.09,11.75,11.75,0,0,0,5.53,4.16,12,12,0,0,0,11.32-1.67,12.24,12.24,0,0,0,4.44-6.59,27.24,27.24,0,0,0,.48-2.94,9.89,9.89,0,0,1-.06,1.72,9.09,9.09,0,0,1-.23,1.27,12.14,12.14,0,0,1-4.41,6.83,12.24,12.24,0,0,1-11.7,1.83,11.28,11.28,0,0,1-3.15-1.68,11.52,11.52,0,0,1-2.63-2.63,12.32,12.32,0,0,1,0-14.69,12.38,12.38,0,0,1,5.78-4.31,12.42,12.42,0,0,1,6.51-.51,12.22,12.22,0,0,1,5.19,2.35,12.09,12.09,0,0,1,4.41,6.82,9,9,0,0,1,.23,1.28,5.69,5.69,0,0,1,.07.94A5.82,5.82,0,0,1,522.12,155.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,289.65a2.42,2.42,0,0,1-2.42-2.41V282a2.42,2.42,0,1,1,4.83,0v5.26A2.41,2.41,0,0,1,195,289.65Zm0-9.09a1.43,1.43,0,0,0-1.42,1.42v5.26a1.42,1.42,0,0,0,2.83,0V282A1.42,1.42,0,0,0,195,280.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,292.15a5.51,5.51,0,0,1-5.51-5.5.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5,4.51,4.51,0,0,0,9,0,.5.5,0,0,1,1,0A5.51,5.51,0,0,1,195,292.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,295.2a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3A.5.5,0,0,1,195,295.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.28,295H235a.5.5,0,0,1-.5-.5V280.23a.5.5,0,0,1,.5-.5h14.3a.5.5,0,0,1,.5.5v14.31A.5.5,0,0,1,249.28,295Zm-13.8-1h13.3V280.73h-13.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.35,292.07a.48.48,0,0,1-.39-.18l-2.84-3.53-2,2.44a.47.47,0,0,1-.35.18.45.45,0,0,1-.38-.13l-1.67-1.55c-1,1.12-2,2.28-2.16,2.5a.5.5,0,0,1-.94-.23c0-.24,0-.28,2.69-3.32a.46.46,0,0,1,.35-.16.45.45,0,0,1,.36.13l1.66,1.53,2-2.5a.51.51,0,0,1,.78,0l3.22,4a.49.49,0,0,1-.07.7A.45.45,0,0,1,247.35,292.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.35,287.39a1.56,1.56,0,1,1,1.56-1.56A1.56,1.56,0,0,1,241.35,287.39Zm0-2.12a.56.56,0,1,0,.56.56A.56.56,0,0,0,241.35,285.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.06,294.29H282.91a.5.5,0,0,1-.5-.5V283.26a.5.5,0,0,1,.5-.5H286l1.43-1.43a.5.5,0,0,1,.35-.14h4.31a.5.5,0,0,1,.35.14l1.43,1.43h3.21a.5.5,0,0,1,.5.5v10.53A.5.5,0,0,1,297.06,294.29Zm-13.65-1h13.15v-9.53h-2.92a.47.47,0,0,1-.35-.15l-1.43-1.42H288l-1.43,1.42a.47.47,0,0,1-.35.15h-2.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,292.24a3.65,3.65,0,1,1,3.64-3.64A3.66,3.66,0,0,1,290,292.24Zm0-6.29a2.65,2.65,0,1,0,2.64,2.65A2.65,2.65,0,0,0,290,286Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.63,287.36a2,2,0,1,1-2-2A2,2,0,0,1,333.63,287.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.44,287.36a2,2,0,1,1-2-2A2,2,0,0,1,339.44,287.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.24,287.36a2,2,0,1,1-2-2A2,2,0,0,1,345.24,287.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.25,260.16c0,.14-75.05.26-167.61.26S181,260.3,181,260.16s75-.26,167.64-.26S516.25,260,516.25,260.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.53,229.59,196,240.25h-1.6l-2.9-8.52-2.91,8.52h-1.63l-3.57-10.66h1.57l2.88,8.66,3-8.66h1.4l2.94,8.71,2.94-8.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05,235.6v4.65h-1.46v-4.48c0-1.58-.79-2.36-2.18-2.36a2.4,2.4,0,0,0-2.56,2.68v4.16h-1.46V229h1.46v4.37a3.5,3.5,0,0,1,2.85-1.22C207.67,232.1,209.05,233.23,209.05,235.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.15,235.37v4.88h-1.38v-1.07a3,3,0,0,1-2.65,1.16c-1.83,0-3-1-3-2.38s.84-2.36,3.25-2.36h2.31v-.29c0-1.23-.71-1.95-2.16-1.95a4.09,4.09,0,0,0-2.56.87l-.61-1.09a5.39,5.39,0,0,1,3.34-1C216.9,232.1,218.15,233.17,218.15,235.37Zm-1.46,2.41v-1.13h-2.25c-1.45,0-1.86.57-1.86,1.25s.67,1.31,1.78,1.31A2.33,2.33,0,0,0,216.69,237.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.4,239.77a2.71,2.71,0,0,1-1.77.57,2.31,2.31,0,0,1-2.56-2.53v-4.43H219.7v-1.2h1.37v-1.77h1.46v1.77h2.32v1.2h-2.32v4.37a1.19,1.19,0,0,0,1.27,1.35,1.8,1.8,0,0,0,1.14-.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.27,229h1.86l-2.56,2H229.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.27,239.39l.61-1.15a5.25,5.25,0,0,0,2.83.83c1.36,0,1.92-.41,1.92-1.09,0-1.81-5.1-.25-5.1-3.46,0-1.45,1.3-2.42,3.37-2.42a5.84,5.84,0,0,1,2.94.73l-.63,1.16a4.23,4.23,0,0,0-2.33-.64c-1.28,0-1.9.47-1.9,1.11,0,1.9,5.12.35,5.12,3.49,0,1.46-1.34,2.39-3.49,2.39A5.79,5.79,0,0,1,235.27,239.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.27,236.21a4.2,4.2,0,1,1,4.2,4.13A4,4,0,0,1,247.27,236.21Zm6.91,0a2.72,2.72,0,1,0-5.44,0,2.72,2.72,0,1,0,5.44,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.34,235.6v4.65h-1.46v-4.48c0-1.58-.79-2.36-2.18-2.36a2.4,2.4,0,0,0-2.56,2.68v4.16h-1.46v-8.07h1.4v1.21A3.46,3.46,0,0,1,262,232.1C264,232.1,265.34,233.23,265.34,235.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.28,232.18l-3.91,8.87c-.72,1.71-1.65,2.24-2.88,2.24a3,3,0,0,1-2.07-.74l.62-1.1a2.08,2.08,0,0,0,1.45.59c.7,0,1.14-.32,1.54-1.24l.26-.57-3.57-8h1.53l2.81,6.45,2.79-6.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.67,236.21a4.2,4.2,0,1,1,4.21,4.13A4,4,0,0,1,279.67,236.21Zm6.92,0a2.72,2.72,0,1,0-2.71,2.85A2.65,2.65,0,0,0,286.59,236.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.61,232.18v8.07h-1.39V239a3.27,3.27,0,0,1-2.74,1.31,3.17,3.17,0,0,1-3.47-3.52v-4.64h1.46v4.47c0,1.59.79,2.38,2.18,2.38a2.38,2.38,0,0,0,2.5-2.68v-4.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,232.1v1.42a1.94,1.94,0,0,0-.33,0,2.41,2.41,0,0,0-2.55,2.73v4h-1.46v-8.07h1.4v1.35A3.09,3.09,0,0,1,304.73,232.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.13,235.6v4.65h-1.47v-4.48c0-1.58-.76-2.36-2.08-2.36s-2.42.93-2.42,2.68v4.16h-1.47v-4.48c0-1.58-.76-2.36-2.08-2.36s-2.42.93-2.42,2.68v4.16h-1.46v-8.07h1.4v1.2a3.25,3.25,0,0,1,2.78-1.28,3,3,0,0,1,2.8,1.49,3.65,3.65,0,0,1,3.11-1.49C322.79,232.1,324.13,233.23,324.13,235.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.56,229.68a1,1,0,0,1,1-1,1,1,0,1,1-1,1Zm.25,2.5h1.47v8.07h-1.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.72,235.6v4.65h-1.46v-4.48c0-1.58-.79-2.36-2.18-2.36a2.4,2.4,0,0,0-2.56,2.68v4.16h-1.46v-8.07h1.4v1.21a3.47,3.47,0,0,1,2.91-1.29C337.33,232.1,338.72,233.23,338.72,235.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.09,229v11.3h-1.4V239a3.44,3.44,0,0,1-2.88,1.37,4.12,4.12,0,0,1,0-8.24,3.44,3.44,0,0,1,2.81,1.29V229Zm-1.45,7.26a2.72,2.72,0,1,0-2.71,2.85A2.65,2.65,0,0,0,347.64,236.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.62,232.4c0-1-.81-1.64-2.18-1.64a3.24,3.24,0,0,0-2.72,1.2l-1.12-.79a4.75,4.75,0,0,1,3.95-1.7c2.19,0,3.61,1,3.61,2.71,0,2.54-2.7,2.71-2.7,4.7h-1.52C353.94,234.49,356.62,234.16,356.62,232.4Zm-2.89,7a1,1,0,1,1,1,1A1,1,0,0,1,353.73,239.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,182.54c0,1.6-1.16,2.57-3.08,2.57h-1.83v2.24h-1.05V180H249C250.87,180,252,180.93,252,182.54Zm-1.05,0c0-1.06-.71-1.66-2.06-1.66h-1.8v3.31h1.8C250.27,184.19,251,183.59,251,182.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.76,181.76v5.59h-1v-.84a2.28,2.28,0,0,1-1.9.91,2.2,2.2,0,0,1-2.41-2.44v-3.22h1v3.1c0,1.1.55,1.65,1.51,1.65a1.65,1.65,0,0,0,1.74-1.86v-2.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.49,184.55a2.73,2.73,0,0,1-2.83,2.87,2.38,2.38,0,0,1-2-1v.89h-1v-7.83h1v3.08a2.38,2.38,0,0,1,2-.9A2.71,2.71,0,0,1,266.49,184.55Zm-1,0a1.88,1.88,0,1,0-1.88,2A1.84,1.84,0,0,0,265.46,184.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.89,179.52h1v7.83h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.66,180a.67.67,0,0,1,.69-.66.65.65,0,0,1,.68.64.69.69,0,0,1-1.37,0Zm.18,1.74h1v5.59h-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.27,184.55a2.8,2.8,0,0,1,3-2.85,2.49,2.49,0,0,1,2.28,1.2l-.77.49a1.74,1.74,0,0,0-1.52-.8,2,2,0,0,0,0,3.94,1.77,1.77,0,0,0,1.52-.8l.77.48a2.52,2.52,0,0,1-2.28,1.21A2.81,2.81,0,0,1,273.27,184.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.09,182.82l2.52,2.43a.45.45,0,0,0,.61,0l2.55-2.47a.46.46,0,0,0-.35-.77h-5A.47.47,0,0,0,289.09,182.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.86,156.05v10.66h-1.63l-5.88-7.22v7.22h-2V156.05H248l5.88,7.22v-7.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.28,156.1a1.15,1.15,0,0,1,1.21-1.14,1.13,1.13,0,0,1,1.22,1.09,1.17,1.17,0,0,1-1.22,1.19A1.15,1.15,0,0,1,258.28,156.1Zm.25,2.48h1.91v8.13h-1.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.26,162.65a4.12,4.12,0,0,1,4.4-4.16,3.66,3.66,0,0,1,3.48,1.89l-1.47.85a2.28,2.28,0,0,0-2-1.13,2.55,2.55,0,0,0,0,5.09,2.28,2.28,0,0,0,2-1.13l1.47.85a3.71,3.71,0,0,1-3.48,1.91A4.13,4.13,0,0,1,262.26,162.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,163.22l-1.42,1.34v2.15h-1.9v-11.3h1.9v6.82l3.95-3.65h2.28L276.44,162l3.71,4.72h-2.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.32,162.05v4.66h-1.91V162.3c0-1.45-.71-2.15-1.93-2.15a2.16,2.16,0,0,0-2.27,2.45v4.11h-1.9v-8.13h1.81v1a3.51,3.51,0,0,1,2.8-1.14C287.87,158.49,289.32,159.6,289.32,162.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.54,162v4.76h-1.8v-1a2.88,2.88,0,0,1-2.56,1.1c-1.85,0-3-1-3-2.44s.92-2.42,3.38-2.42h2.11v-.12c0-1.11-.67-1.77-2-1.77a4.06,4.06,0,0,0-2.47.81l-.74-1.39a5.71,5.71,0,0,1,3.44-1C297.18,158.49,298.54,159.6,298.54,162Zm-1.9,2.22v-.95h-2c-1.29,0-1.64.49-1.64,1.09s.58,1.12,1.55,1.12A2.07,2.07,0,0,0,296.64,164.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.57,162.05v4.66h-1.9V162.3c0-1.45-.67-2.15-1.83-2.15s-2.12.82-2.12,2.43v4.13h-1.9V162.3c0-1.45-.67-2.15-1.83-2.15s-2.11.82-2.11,2.43v4.13H301v-8.13h1.81v1a3.36,3.36,0,0,1,2.67-1.13,3,3,0,0,1,2.74,1.35,3.81,3.81,0,0,1,3.05-1.35C313.2,158.49,314.57,159.6,314.57,162.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.69,163.25h-6.38a2.46,2.46,0,0,0,2.63,1.95,2.92,2.92,0,0,0,2.21-.88l1,1.17a4.11,4.11,0,0,1-3.27,1.33c-2.73,0-4.49-1.75-4.49-4.17a4,4,0,0,1,4.2-4.16,4,4,0,0,1,4.11,4.2C324.72,162.84,324.7,163.07,324.69,163.25Zm-6.4-1.26h4.62a2.21,2.21,0,0,0-2.3-2A2.26,2.26,0,0,0,318.29,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.38,302.76H428.07a14.67,14.67,0,0,1-14.66-14.66h0a14.66,14.66,0,0,1,14.66-14.66h64.31A14.66,14.66,0,0,1,507,288.1h0A14.66,14.66,0,0,1,492.38,302.76Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.2,288v-4.1h1V288c0,1.6.74,2.32,2,2.32s2-.72,2-2.32v-4.06h1V288c0,2.09-1.15,3.2-3.05,3.2S439.2,290.1,439.2,288Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.25,286.42c0,1.57-1.13,2.52-3,2.52h-1.78v2.19h-1v-7.22h2.81C452.12,283.91,453.25,284.85,453.25,286.42Zm-1,0c0-1-.69-1.62-2-1.62h-1.75V288h1.75C451.53,288,452.22,287.45,452.22,286.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.77,283.91h3.05a3.62,3.62,0,1,1,0,7.22h-3.05Zm3,6.32a2.72,2.72,0,1,0,0-5.43H455.8v5.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.79,289.32H464l-.8,1.81H462.1l3.27-7.22h1l3.28,7.22h-1.08Zm-.36-.82L465.87,285l-1.55,3.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.82,284.8h-2.48v-.89h6v.89h-2.48v6.33h-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.68,290.23v.9h-5.24v-7.22h5.1v.89h-4.07V287h3.63v.88h-3.63v2.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Avatar--inject-259"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 171.02,
    cy: 146.39,
    r: 65.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.56,188.66a67.19,67.19,0,0,0,5.57,5.87l3.33-9.43s-1.61-3.47-3.2-7C124.23,182.06,122.15,185.84,120.56,188.66Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.27,155.65c-6.2-1.62-18.07-3.42-18.07-3.42l-26.62,2.1a35.4,35.4,0,0,0-12.6,4.28c.27,2.71.43,4.72.43,4.72s2.29,3.18,3.59,5.45a8.2,8.2,0,0,1,.84,1.8c.35,1.6-.89,10.45-.89,10.45l.1,4.22.46,20.95a65.88,65.88,0,0,0,50.36,2l3.58-17.21,8.12,8.73c.16-.41.34-.79.51-1.18,4.22-9.65,11.18-12.22,18.5-13.85l.13-.18c.11-.15.21-.3.32-.44C222.08,180.56,202,157.16,196.27,155.65Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.48,128.51c-2.34-2.8-5.19-5.66-5.29-9.31-.06-1.93.65-4.11-.51-5.66-1-1.35-3-1.56-4.15-2.81-1.52-1.66-.87-4.29-1.39-6.48a7.56,7.56,0,0,0-4.9-5.06,15.72,15.72,0,0,0-7.25-.55l-2.28,50.16a6.13,6.13,0,0,1,5.55-1.14c1.54.59,3,1.54,4.63,1.68,3.69.3,6.29-3.39,9.44-5.33s7.15-2.44,8.81-5.57S208.81,131.31,206.48,128.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.58,144.39a4,4,0,0,0,1.23-.51,2.67,2.67,0,0,0,1-1.16,2.74,2.74,0,0,0,0-2,3.66,3.66,0,0,0-1.67-1.74,4.44,4.44,0,0,1-1.12-1,2.34,2.34,0,0,1-.47-1.55,11.19,11.19,0,0,1,1-3.14,4.73,4.73,0,0,0,.34-1.6,2.91,2.91,0,0,0-.48-1.55,9.41,9.41,0,0,0-2.49-2.3,13.71,13.71,0,0,1-2.51-2.13,10.63,10.63,0,0,1-2.41-5,10.06,10.06,0,0,1,0-3.74,6.77,6.77,0,0,1,.26-1,1.27,1.27,0,0,1,.14-.33s-.11.47-.22,1.34a10.65,10.65,0,0,0,.15,3.65,10.49,10.49,0,0,0,2.4,4.78,13.25,13.25,0,0,0,2.46,2.05A9.46,9.46,0,0,1,199.8,130a3.28,3.28,0,0,1,.55,1.79,5,5,0,0,1-.37,1.75,11.23,11.23,0,0,0-1,3,1.93,1.93,0,0,0,.37,1.29,4,4,0,0,0,1,.91,6.84,6.84,0,0,1,1.07.84,2.76,2.76,0,0,1,.69,1.1,2.94,2.94,0,0,1-.1,2.18,2.88,2.88,0,0,1-2.08,1.56A.79.79,0,0,1,199.58,144.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.29,155.54l-.16-8.42s8.36-1.24,10.29-12.09c1-5.39.84-14.27.51-21.53-.3-6.53-7.21-13.17-13.73-12.6L157,104.54v3.51l.59,47.85a11.83,11.83,0,0,0,11.83,11.69h0A11.83,11.83,0,0,0,181.29,155.54Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.31,120.58a1.4,1.4,0,0,1-1.37,1.39,1.34,1.34,0,0,1-1.42-1.29,1.4,1.4,0,0,1,1.37-1.38A1.34,1.34,0,0,1,188.31,120.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.92,118.08c-.17.18-1.22-.62-2.72-.64s-2.61.71-2.77.52.1-.41.59-.75a3.8,3.8,0,0,1,2.22-.64,3.63,3.63,0,0,1,2.16.74C189.86,117.67,190,118,189.92,118.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.81,120.12a1.41,1.41,0,0,1-1.38,1.39,1.34,1.34,0,0,1-1.41-1.29,1.4,1.4,0,0,1,1.37-1.38A1.34,1.34,0,0,1,173.81,120.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.16,118.1c-.18.18-1.22-.62-2.72-.64s-2.62.71-2.78.52.1-.41.59-.75a3.84,3.84,0,0,1,2.23-.64,3.69,3.69,0,0,1,2.16.74C175.09,117.69,175.24,118,175.16,118.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.41,129.33a10.05,10.05,0,0,1,2.45-.39c.38,0,.74-.11.81-.37a1.89,1.89,0,0,0-.23-1.14q-.52-1.4-1.08-2.94c-1.51-4.18-2.58-7.62-2.42-7.68s1.53,3.29,3,7.47l1,3a2.18,2.18,0,0,1,.17,1.51,1,1,0,0,1-.64.55,2.22,2.22,0,0,1-.65.07A9.23,9.23,0,0,1,180.41,129.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.13,147.12a27.67,27.67,0,0,1-14.5-4.15s3.64,7.6,14.55,6.78Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.71,132.94a2.74,2.74,0,0,0-2.41-1.05,2.47,2.47,0,0,0-1.72.89,1.56,1.56,0,0,0-.15,1.79,1.83,1.83,0,0,0,2,.53,5.72,5.72,0,0,0,1.94-1.11,1.84,1.84,0,0,0,.44-.44.52.52,0,0,0,0-.56",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,130.29c.25,0,.22,1.62,1.59,2.81s3.12,1,3.13,1.26-.4.31-1.13.31a4,4,0,0,1-2.61-1,3.53,3.53,0,0,1-1.23-2.34C175.67,130.68,175.86,130.28,176,130.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.65,112.22c-.16.41-1.65.19-3.42.37s-3.2.64-3.42.27c-.1-.18.15-.56.73-1a6,6,0,0,1,5.21-.48C175.4,111.71,175.72,112,175.65,112.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.45,113.73c-.27.33-1.3,0-2.54-.08s-2.31.19-2.54-.17c-.11-.17.07-.51.53-.83a3.58,3.58,0,0,1,2.08-.52,3.52,3.52,0,0,1,2,.72C189.43,113.21,189.57,113.56,189.45,113.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.58,117.36c3.58-4.39,13.76-12.28,18.72-14.46.79-.34,1.53-1.08,2-1.08a15.58,15.58,0,0,1,2.91,2c2.64,2.31,4.74,7.75,5.76,11.11,1.47-4.18,1-10.19-1.92-13.54s-6-5.2-10.42-5.42A18.71,18.71,0,0,0,168.11,99c-1.49.92-6.88,5.41-8.39,8Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.63,96.17c.73.08-4.21-4-7.28-4.52a12.33,12.33,0,0,0-9,1.87c-1.76,1.18-3.23,2.82-5.18,3.65a42.77,42.77,0,0,1-4.68,1.2,10.85,10.85,0,0,0-7.55,9.37c-.14,1.81.19,3.61.22,5.42a7.24,7.24,0,0,1-1.53,5.08c-1.06,1.15-2.62,1.68-3.95,2.52a9.79,9.79,0,0,0-4.34,9.63c.32,2,1.26,4,.58,5.9-.45,1.24-1.53,2.13-2.26,3.23a6.58,6.58,0,0,0,.24,7.4c1.84.2,3.3,1.58,4.73,2.76s3.26,2.26,5,1.74c2.31-.68,3.4-3.76,5.78-4.1s4,2.14,6.24,3c2.51,1,5.45-.48,7-2.69s1.89-5,1.94-7.7c.07-3.38-.36-6.94-2.36-9.66-1.43-2-3.71-3.63-3.74-6.05s2.08-4.15,2.43-6.45c.31-2-.77-3.93-1.6-5.79s-2.38-4.6-1.21-6.26C161.16,105.69,169.18,94.78,181.63,96.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.61,98s.38.17.67.74a2.8,2.8,0,0,1-1.81,4c-.62.15-1,0-1,0s.38-.08.9-.29A2.73,2.73,0,0,0,183,98.86C182.8,98.32,182.55,98,182.61,98Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.66,102.63c0,.12-.76,0-1.45-.56s-1-1.22-.89-1.27.54.42,1.17.91S185.7,102.51,185.66,102.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.47,99.79c0-.13.66-.11,1.4-.31s1.28-.53,1.36-.43-.4.64-1.25.87S178.44,99.9,178.47,99.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.55,97.79c0-.12.65-.13,1.41,0s1.37.31,1.35.43-.65.13-1.41,0S178.53,97.92,178.55,97.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.91,98.46c0,.13-.25.25-.57.27s-.59,0-.6-.18.24-.25.57-.27S185.9,98.34,185.91,98.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,99.71c0,.12-.37.23-.84.23s-.83-.11-.83-.23.37-.23.83-.23S186,99.58,186,99.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.83,107c.09.1-1.05,1.27-2.2,2.9s-1.88,3.09-2,3a11.81,11.81,0,0,1,4.2-5.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.22,103.79c.11.09-1.22,1.73-2.58,3.94s-2.23,4.12-2.36,4.07a14.37,14.37,0,0,1,2-4.31A14.16,14.16,0,0,1,167.22,103.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.89,119.3s-.11-.09-.27-.28a3.53,3.53,0,0,1-.5-1,4.47,4.47,0,0,1,.61-3.89,5,5,0,0,1,5.46-1.71,10.42,10.42,0,0,1,3.06,1.72,4.86,4.86,0,0,0,1.57.76,2,2,0,0,0,1.6-.34,2.74,2.74,0,0,0,.91-1.45,4.84,4.84,0,0,0,.08-1.74c-.13-1.16-.41-2.32-.44-3.44a8.27,8.27,0,0,1,1.54-5.66,5.42,5.42,0,0,1,3.4-2,3.89,3.89,0,0,1,1.09,0,2.09,2.09,0,0,1,.37.09,8.38,8.38,0,0,0-1.43.09,5.41,5.41,0,0,0-3.18,2,8.08,8.08,0,0,0-1.37,5.44c0,1.09.32,2.19.47,3.42A3.87,3.87,0,0,1,149.7,115a2.4,2.4,0,0,1-2,.42,5.53,5.53,0,0,1-1.71-.82,10.25,10.25,0,0,0-2.93-1.69,4.72,4.72,0,0,0-5.09,1.49,4.36,4.36,0,0,0-.7,3.65A5.49,5.49,0,0,0,137.89,119.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.75,120.11a2.89,2.89,0,0,0-.37,0,1.18,1.18,0,0,0-.86.51,1.13,1.13,0,0,0,0,1.45,1.7,1.7,0,0,0,1.92.41,2.53,2.53,0,0,0,1.35-2.07,6.77,6.77,0,0,0-.56-3,5.26,5.26,0,0,0-1.9-2.71,2.65,2.65,0,0,0-1.65-.34,10.73,10.73,0,0,0-1.82.41,5.9,5.9,0,0,1-2,.26,2.56,2.56,0,0,1-1.75-.93,4.63,4.63,0,0,1-.82-3.49c.13-1.14.39-2.17.4-3.14a6.22,6.22,0,0,0-.53-2.62,7,7,0,0,0-2.45-3c-.77-.52-1.28-.69-1.26-.73a1.52,1.52,0,0,1,.37.1,5.66,5.66,0,0,1,1,.48,7,7,0,0,1,2.65,3,6.62,6.62,0,0,1,.61,2.75c0,1-.25,2.09-.36,3.18a4.27,4.27,0,0,0,.74,3.17,2.18,2.18,0,0,0,1.46.76,5.51,5.51,0,0,0,1.8-.25,10.81,10.81,0,0,1,1.91-.42,3.07,3.07,0,0,1,1.92.41,5.72,5.72,0,0,1,2.06,2.95,7.05,7.05,0,0,1,.54,3.19,2.89,2.89,0,0,1-1.6,2.33,2,2,0,0,1-2.25-.55,1.26,1.26,0,0,1-.28-1,1.45,1.45,0,0,1,.34-.76,1.31,1.31,0,0,1,1-.5A.65.65,0,0,1,204.75,120.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.26,134.42a1.89,1.89,0,0,0,.35.06,1,1,0,0,0,.78-.51.87.87,0,0,0,.12-.64,1,1,0,0,0-.48-.61,1.52,1.52,0,0,0-1.83.28,3.39,3.39,0,0,0-.87,2.28,2.39,2.39,0,0,0,.34,1.3,2,2,0,0,0,1.12.8,2.71,2.71,0,0,0,2.8-.9,5.05,5.05,0,0,0,1.07-3.19,25.88,25.88,0,0,0-.34-3.54,9.49,9.49,0,0,1,.09-3.41,5.82,5.82,0,0,1,1.55-2.68,8.53,8.53,0,0,1,2.19-1.56,16.09,16.09,0,0,1,3.66-1.18,7.18,7.18,0,0,1,1.39-.22,10.34,10.34,0,0,1-1.35.39,17.93,17.93,0,0,0-3.55,1.3,8.25,8.25,0,0,0-2.07,1.53,5.65,5.65,0,0,0-1.42,2.52,9.05,9.05,0,0,0,0,3.25,24.17,24.17,0,0,1,.34,3.61,5.4,5.4,0,0,1-1.19,3.48,3.27,3.27,0,0,1-1.51,1,3.08,3.08,0,0,1-1.73,0,2.35,2.35,0,0,1-1.35-1,2.76,2.76,0,0,1-.38-1.51,3.69,3.69,0,0,1,1-2.51,1.78,1.78,0,0,1,2.18-.27,1.23,1.23,0,0,1,.56.78,1.07,1.07,0,0,1-.18.79,1.06,1.06,0,0,1-.94.5A.5.5,0,0,1,133.26,134.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.58,92.93a2.24,2.24,0,0,1-.14-.35,1.47,1.47,0,0,0-.74-.69,2.33,2.33,0,0,0-1.59-.09,1.73,1.73,0,0,0-1.34,1.43c-.28,1.55,1.51,3.51,3.65,3.13a5.91,5.91,0,0,0,3-1.43,17.25,17.25,0,0,0,2.43-2.76,16.52,16.52,0,0,1,2.52-2.81,6.18,6.18,0,0,1,3.22-1.48,4.83,4.83,0,0,1,3.12.82,6.56,6.56,0,0,1,1.94,2A10.69,10.69,0,0,1,181,94.47c.08.47.12.83.14,1.08a1,1,0,0,1,0,.38s-.11-.51-.31-1.42a11.16,11.16,0,0,0-1.42-3.63A6.44,6.44,0,0,0,177.48,89a4.49,4.49,0,0,0-2.86-.71,5.78,5.78,0,0,0-3,1.41,16.66,16.66,0,0,0-2.44,2.74,17.33,17.33,0,0,1-2.5,2.82,6.35,6.35,0,0,1-3.22,1.51,3.62,3.62,0,0,1-3.05-1,3,3,0,0,1-1-2.62,1.9,1.9,0,0,1,.6-1.12,2.13,2.13,0,0,1,1-.51,2.5,2.5,0,0,1,1.73.18,1.43,1.43,0,0,1,.74.82A.92.92,0,0,1,163.58,92.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,95.92a.82.82,0,0,1-.08-.18,1.79,1.79,0,0,0-.23-.48,3.2,3.2,0,0,0-1.62-1.18,8.69,8.69,0,0,0-3.22-.45,7.52,7.52,0,0,0-2,.3,6.5,6.5,0,0,0-2,1.13A15.26,15.26,0,0,0,164.44,99a8.45,8.45,0,0,0-.63,1.28,3.86,3.86,0,0,1-.8,1.34,6.33,6.33,0,0,1-2.76,1.66,12.06,12.06,0,0,1-1.61.32,7.08,7.08,0,0,0-1.53.52,6.44,6.44,0,0,0-2.52,2.12,5.42,5.42,0,0,0-.92,3.24,22.9,22.9,0,0,0,.43,3.61,11.62,11.62,0,0,1,.17,3.72,5.36,5.36,0,0,1-1.75,3.19c-1.8,1.63-4.06,2.29-5.64,3.69a5.51,5.51,0,0,0-1.77,2.41,3.64,3.64,0,0,0,.24,2.73c.38.85.92,1.61,1.29,2.45a4.09,4.09,0,0,1,.38,2.58,3.45,3.45,0,0,1-1.44,1.89A16.47,16.47,0,0,0,144,137a3.51,3.51,0,0,0-1,2.94,10.85,10.85,0,0,0,.39,2,4.26,4.26,0,0,1,.18.7.81.81,0,0,1-.08-.17c0-.11-.11-.28-.19-.51a9.27,9.27,0,0,1-.48-2.05,4.5,4.5,0,0,1,.08-1.53,3.38,3.38,0,0,1,.91-1.6,17,17,0,0,1,1.64-1.28,3.14,3.14,0,0,0,1.3-1.73,3.8,3.8,0,0,0-.39-2.37c-.36-.79-.9-1.54-1.32-2.43a4,4,0,0,1-.27-3,6,6,0,0,1,1.88-2.6c1.66-1.47,3.92-2.15,5.61-3.69a4.91,4.91,0,0,0,1.6-2.94,11.14,11.14,0,0,0-.17-3.58,22.81,22.81,0,0,1-.43-3.68,5.92,5.92,0,0,1,1-3.5,6.8,6.8,0,0,1,2.7-2.25,7.09,7.09,0,0,1,1.63-.54,10.51,10.51,0,0,0,1.58-.32,5.74,5.74,0,0,0,2.58-1.52,3.23,3.23,0,0,0,.73-1.22,9.61,9.61,0,0,1,.67-1.32,15.46,15.46,0,0,1,3.58-4,6.51,6.51,0,0,1,2.06-1.15,7.49,7.49,0,0,1,2.08-.29,8.66,8.66,0,0,1,3.29.55,3.08,3.08,0,0,1,1.64,1.3,1.63,1.63,0,0,1,.2.51C177,95.85,177,95.91,177,95.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.11,203.64a.78.78,0,0,1,.7-.46,6.52,6.52,0,0,1,.88.07,7.73,7.73,0,0,0,2.94-.74,8.75,8.75,0,0,1,4.13-.31,6.54,6.54,0,0,0,3.15.22c.56-.19,1.1-.6,1.68-.49a8.62,8.62,0,0,1,1,.47,2.62,2.62,0,0,0,2.3-.68,3.4,3.4,0,0,1,2.26-.92,3.57,3.57,0,0,1,1.74,1.1,2.37,2.37,0,0,0,1.84.82c1.25-.2,1.79-2.09,3.05-2,.87,0,1.36,1,1.62,1.82s.37,1.71,1.21,1.93l-.66,3.18a2.87,2.87,0,0,1-3,2.39,6.21,6.21,0,0,1-3.76-1.85,11.35,11.35,0,0,0-2.14-1.73,9.19,9.19,0,0,0-4.7-.58,53.86,53.86,0,0,1-13.1-1.11,2.08,2.08,0,0,1-.84-.31A.72.72,0,0,1,166.11,203.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.09,183.45a8.39,8.39,0,0,1,1.55-3.56c.49-.54,1.17-1,1.23-1.76,0-.53-.25-1.06-.12-1.57.23-1,1.59-1,2.56-.78s2.27.34,2.68-.57-.82-2.4-.08-3.25a1.75,1.75,0,0,1,1.23-.44c1.3-.12,1-.47,2.27-.59l5.17,5.52c-.55-1-4.92-.4-5.6.52a11.78,11.78,0,0,0-1.16,3.22c-.38,1.09-1.35,2.18-2.47,2-.86-.16-1.49-1-2.36-1s-1.51.86-1.7,1.72-.07,1.74-.26,2.59-.86,1.72-1.73,1.67a1.72,1.72,0,0,1-1.44-1.46A5,5,0,0,1,202.09,183.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.49,157.84c1.55-.09,3.44.06,4.13,1.44.45.92.17,2.1.72,3s1.83,1.07,2.91,1.2,2.34.44,2.73,1.45-.22,2.15.31,3c.65,1.07,2.24.74,3.47,1,2.28.41,3.68,3,6,3.43A8.17,8.17,0,0,0,164,172a4.53,4.53,0,0,1,3.21.21c.94.56,1.37,2,.56,2.77a2.7,2.7,0,0,1-2.15.38l-6.61-.67a35,35,0,0,1-5.19-.8,34.22,34.22,0,0,1-4-1.41c-1.7-.67-3.54-1.48-4.34-3.13a11.16,11.16,0,0,0-.93-2.08,4.28,4.28,0,0,0-2-1.21l-5.9-2.35a3,3,0,0,1-1.41-.91,1,1,0,0,1,.19-1.48S139.25,157.92,140.49,157.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.05,179.57c.78-1.24,2.79-.62,4-1.41,2.28-1.46-.14-5.69,1.84-7.52,1.5-1.4,4.47-.27,5.64-1.95.69-1,.31-2.41.92-3.44,1.54-2.58,6.58.29,8.21-2.23a4.31,4.31,0,0,0,.38-2.57,3.52,3.52,0,0,1,.56-2.52c.58-.67,1.61.14,1.61.14a105.39,105.39,0,0,1,8.05,7.47c-1.43-.3-2.89-.72-3.9-.25a6.7,6.7,0,0,0-2.32,2.35,5.75,5.75,0,0,1-2.4,2.24c-2.06.77-4.81-.78-6.37.77-.89.89-.82,2.33-1.23,3.53-1,2.86-5.34,3.77-7.38,1.53a6.35,6.35,0,0,1-4.12,6.31,3.41,3.41,0,0,1-2.73-.07A1.8,1.8,0,0,1,177.05,179.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.94,191.24a7.45,7.45,0,0,1,3.69-.43,7.23,7.23,0,0,0,2.39.52c1.68-.21,2.56-2.59,4.25-2.51s2.71,2.9,4.46,2.58c1-.18,1.64-1.31,2.62-1.25s1.48,1.46,2.3,2.18a3.72,3.72,0,0,0,3.39.36,8.91,8.91,0,0,1,3.46-.64c1.18.16,2.32,1.32,1.92,2.43l.93-.41c.67-.36,1.41.65,1.11,1.35a2.45,2.45,0,0,1-1.87,1.16c-2.78.57-5.67.07-8.47-.44L153.68,195a32.7,32.7,0,0,0-6.46-.72,15.84,15.84,0,0,0-4.82.87,10,10,0,0,1-3.17.81,2.37,2.37,0,0,1-2.43-1.78C136.6,192.6,138.44,191.68,139.94,191.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.58,184.64c-7.32,1.63-14.28,4.2-18.5,13.85l2,2.28A66.22,66.22,0,0,0,224.58,184.64Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.46 185.1 126.13 194.53 126.13 194.53 129.46 185.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.93,172.73c.59,1.44,1.45,3.4,2.33,5.35l0-.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.35,166.32a5.18,5.18,0,0,1,.7.29c.91-.67,1.84-1.31,2.8-1.92a2.88,2.88,0,0,0-.57-.93,5.36,5.36,0,0,0-1.31-1,15.28,15.28,0,0,0-2.2,3.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.05,166.61a5.18,5.18,0,0,0-.7-.29l-.58-.14c-.11.24-.22.48-.32.73-.17.43-.36.88-.54,1.32.15-.13.3-.27.46-.39C131.92,167.41,132.49,167,133.05,166.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.26,178.08c1.59,3.55,3.2,7,3.2,7L126.29,178Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.91,168.23a3.26,3.26,0,0,0-.58.65,1.76,1.76,0,0,0-.26.8l.2,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.07,169.68a1.39,1.39,0,0,0,0,.41l.17-.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.65,177.07l1.18-6a6.11,6.11,0,0,0-1,1.59A6.18,6.18,0,0,0,134.65,177.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.12,167.73a1.79,1.79,0,0,1-1.27,2,5.23,5.23,0,0,1-2.52,0h-.06l-.17.38a1.17,1.17,0,0,0,.06.2c.35.78,1.39.92,2.24.82a8.77,8.77,0,0,0,3.69-1.35l1.18-6c-.49.28-1,.6-1.42.9a2.4,2.4,0,0,1,.15.79,2.4,2.4,0,0,0-.15-.79c-1,.61-1.89,1.25-2.8,1.92A1.82,1.82,0,0,1,134.12,167.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.84,169.54l-.34-.88a8.77,8.77,0,0,1-1.41,1.1l-.26,1.34A6.13,6.13,0,0,1,137.84,169.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,181s1.24-8.85.89-10.45a8.2,8.2,0,0,0-.84-1.8c-1.3-2.27-3.59-5.45-3.59-5.45s-.16-2-.43-4.72c-.53-5.33-1.47-13.42-2.42-14.43-.76-.81-3.12-1.29-3.17,3.75s0,10.48,0,10.48-7.6-13.16-9.73-13-2.2,1.19,0,5.14a71,71,0,0,1,4.07,9.53,3.56,3.56,0,0,0-2.83,3.21l-.35,2.83s-2.13,2.3-1.24,5c.12.37.34.93.62,1.61l2.36,5.28,3.17,7.09-3.33,9.43q2.06,1.92,4.28,3.66a66,66,0,0,0,9.7,6.33c1.11.59,2.25,1.15,3.4,1.68l-.46-20.95Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.82,179a2.39,2.39,0,0,1-.58-.48,6.12,6.12,0,0,1-1.15-1.78,6,6,0,0,1-.44-3.26,6.38,6.38,0,0,1,2-3.76l.25.38a11.48,11.48,0,0,1-4.24,1.33,4.88,4.88,0,0,1-4.48-2c-.07-.11-.13-.22-.19-.33l-.11-.2.21-.13,6.24-4.11a7.92,7.92,0,0,1,1.51-.83,3,3,0,0,1,1.68-.15,4.64,4.64,0,0,1,2.41,1.63,23,23,0,0,1,1.36,1.92,8.8,8.8,0,0,0,1.1,1.35,6.46,6.46,0,0,0,1.19.87,1,1,0,0,1-.38-.11,3.64,3.64,0,0,1-1-.61,7.68,7.68,0,0,1-1.19-1.33c-.42-.55-.84-1.22-1.41-1.85a4.33,4.33,0,0,0-2.22-1.45,3.74,3.74,0,0,0-2.83,1l-6.23,4.14.09-.33c.06.09.1.2.16.29a4.44,4.44,0,0,0,4,1.79,11,11,0,0,0,4.07-1.25l1.42-.66-1.16,1a6,6,0,0,0-1.92,3.48,6,6,0,0,0,.32,3.1A8.48,8.48,0,0,0,135.82,179Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.61,171.4s.15.13.32.41a4.16,4.16,0,0,1,.52,1.35,2.09,2.09,0,0,1-.75,2.07,1.57,1.57,0,0,1-1.38.19,3.62,3.62,0,0,1-1.22-.71,40.82,40.82,0,0,1-4.81-4.45,42.2,42.2,0,0,1,5.14,4c.65.57,1.45.93,2,.53a1.75,1.75,0,0,0,.66-1.62,5.37,5.37,0,0,0-.35-1.31C131.63,171.59,131.58,171.41,131.61,171.4Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.22,167.7c-.12.09-.76-.58-1.75-1.09s-1.91-.65-1.9-.8,1-.24,2.14.34S129.34,167.62,129.22,167.7Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.08,164.73c-.13.07-.85-1-2.05-2a12.24,12.24,0,0,0-1.6-1.19,1.51,1.51,0,0,0-.75-.17s0-.12.19-.19a1.06,1.06,0,0,1,.7,0,6.74,6.74,0,0,1,1.81,1.14A4.53,4.53,0,0,1,133.08,164.73Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-259"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.17,453.57l21.92-48.9-12.7-42a55,55,0,0,1,2.54-38.53l21.36-45.68,14.82-7.78,35.19-6.05c1.35.45,34,17.56,34,17.56a65.57,65.57,0,0,1,17,13.85L609,401.77s6.61,20.86,13.09,51.8Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M604.58,348.74q-4.1,15.9-8.2,31.8c-.51,1.95-1.14,4.08-2.84,5.16a8,8,0,0,1-4,.9l-39.93,1.9a22.3,22.3,0,0,0-6.62,1,7.55,7.55,0,0,0-4.75,4.43c-1.13,3.43,1.21,7,3.54,9.72,20,23.69,47.79,39.15,78.62,42.63l-9.89-53.06,4.16-20.79Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M547.06,370.29l.58.06,1.66.23c1.45.2,3.54.48,6.12.79,5.18.63,12.34,1.34,20.28,1.78s15.15.5,20.36.43c2.61,0,4.72-.07,6.17-.12l1.68,0h.59l-.59,0-1.67.08c-1.46.08-3.57.14-6.18.19-5.21.1-12.42.06-20.37-.37s-15.11-1.18-20.28-1.85c-2.59-.33-4.68-.62-6.12-.85l-1.66-.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514,347.9s.31,0,.91.06l2.63.21,9.65.75c8.15.6,19.41,1.33,31.87,1.85s23.75.76,31.93.84l9.68.07h2.63l.91,0s-.31,0-.91,0l-2.63,0c-2.29,0-5.6,0-9.68,0-8.18-.05-19.47-.25-31.94-.78s-23.73-1.27-31.88-1.92c-4.07-.32-7.37-.6-9.64-.81l-2.62-.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.32,328.71l.84.05,2.39.17,8.82.64c7.45.51,17.75,1.13,29.14,1.57s21.7.61,29.17.67l8.84.05h2.4l.84,0-.84,0-2.4,0c-2.09,0-5.11,0-8.84,0-7.47,0-17.79-.18-29.18-.62s-21.69-1.07-29.14-1.62c-3.72-.28-6.73-.52-8.81-.71l-2.4-.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.57,312.06c0-.06,3.24,0,7.23.06s7.24.21,7.24.27-3.24,0-7.24-.06S527.56,312.12,527.57,312.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.59,303.82l.27,0,.8,0,2.91-.09,9.63-.2,9.62-.14h3.71a.84.84,0,0,1,.28,0l-.28,0-.79,0-2.92.08-9.62.2-9.62.14-2.92,0h-1.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.22,444.6l1.13,0,3.24.11,11.91.39c10.06.28,24,.54,39.31.49s29.25-.41,39.31-.77l11.91-.46,3.23-.14c.74,0,1.13,0,1.13,0l-1.12.07-3.24.18c-2.81.15-6.88.33-11.9.53-10.06.4-24,.77-39.32.83s-29.26-.23-39.31-.56c-5-.16-9.1-.32-11.91-.45l-3.24-.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.81,425c0-.06,21.68.42,48.4,1.07s48.4,1.22,48.4,1.28-21.67-.42-48.4-1.07S518.81,425,518.81,425Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.09,404.67h.85l2.45,0,9,.15c7.62.15,18.14.42,29.76.85s22.13,1,29.72,1.53c3.8.29,6.88.51,9,.72l2.44.24.85.09-.85-.05-2.45-.19c-2.12-.19-5.2-.39-9-.66-7.61-.49-18.12-1-29.73-1.47s-22.13-.73-29.75-.92l-9-.21-2.45-.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.79,276.66s-30.65,6.79-34.21,39.76l-3.79,33.69,13.12,4Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.16,360.27a1.66,1.66,0,0,1-.23-.5c-.12-.34-.34-.84-.54-1.51a26.48,26.48,0,0,1-1.06-5.77,38.6,38.6,0,0,1,3.85-18.84c.82-1.71,1.74-3.34,2.65-4.85s1.77-3,2.55-4.44a46.72,46.72,0,0,0,3.44-7.92c.78-2.34,1.34-4.26,1.74-5.58.19-.61.35-1.12.48-1.52a1.74,1.74,0,0,1,.2-.52,3.26,3.26,0,0,1-.1.55c-.1.41-.23.92-.38,1.54-.35,1.34-.85,3.28-1.58,5.65a45.87,45.87,0,0,1-3.38,8c-.77,1.44-1.63,2.93-2.53,4.47s-1.8,3.12-2.62,4.81a39.57,39.57,0,0,0-4,18.59,30.89,30.89,0,0,0,.89,5.75C515,359.53,515.2,360.26,515.16,360.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.79,275.61l10.46-5.47h47.21l10.88,6.32s-45.58,50.47-55.11,51.86C533.24,331.8,543.79,275.61,543.79,275.61Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518,294.23c0-.05,5.05-.23,11.28-.4s11.29-.25,11.29-.19-5.05.24-11.28.4S518,294.29,518,294.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.69,319.56a4,4,0,0,1,.57,0l1.52.13c1.29.12,3.06.26,5,.37s3.75.15,5,.17l1.53,0a2.77,2.77,0,0,1,.56,0,3.69,3.69,0,0,1-.56.05c-.36,0-.88,0-1.53,0-1.29,0-3.08,0-5.05-.12s-3.75-.27-5-.42c-.64-.08-1.16-.14-1.51-.2A2.12,2.12,0,0,1,509.69,319.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.39,296.08c9.25,9.67,11.88,21.84,11.88,32.93v52.38L604,380.48,605.62,334",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.62,320.49a1.4,1.4,0,0,1,0-.43c0-.29.13-.7.26-1.22a29.35,29.35,0,0,1,1.51-4.34,35.25,35.25,0,0,1,8.71-12.3c4.4-4,9.55-6.24,13.42-6.7a13.62,13.62,0,0,1,4.6.17,8.06,8.06,0,0,1,1.2.35,2.11,2.11,0,0,1,.4.17,16.31,16.31,0,0,0-6.15-.32,26.25,26.25,0,0,0-13.13,6.72,38.38,38.38,0,0,0-10.36,16.3C605.79,319.92,605.66,320.5,605.62,320.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.27,381.39a.64.64,0,0,1-.24,0h-3.42l-10-.12L604,380.74h-.26v-.26c0-1.27.07-2.62.11-4,.41-14.14.79-26.93,1.06-36.24.17-4.61.3-8.35.39-11,.05-1.26.1-2.26.13-3l0-.77a1.14,1.14,0,0,1,0-.27,1.52,1.52,0,0,1,0,.27v.78c0,.72,0,1.72,0,3,0,2.64-.13,6.38-.22,11-.23,9.3-.56,22.1-.91,36.23,0,1.36-.08,2.71-.11,4l-.26-.27,33.56.73,10,.27,2.72.1.7,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.57,367.14c0-.06,10.22,0,22.82.19s22.83.34,22.83.39-10.22,0-22.83-.18S605.57,367.2,605.57,367.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.83,342.35l.46,0,1.31.1,4.83.35c4.07.3,9.71.65,15.94.92s11.88.38,16,.43l4.84.05h1.32l.46,0-.46,0-1.32,0-4.84,0c-4.09,0-9.74-.11-16-.38s-11.87-.64-15.94-1l-4.83-.42-1.31-.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607,321.94s2.25-.81,6-1.76a91.27,91.27,0,0,1,29.94-2.4c3.85.34,6.2.78,6.2.78s-.15,0-.44,0l-1.23-.15c-1.07-.14-2.62-.3-4.54-.45a95.63,95.63,0,0,0-29.9,2.4c-1.87.45-3.38.86-4.41,1.16l-1.19.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "514.91 361.14 501.99 337.3 462.68 337.3 461.43 339.67 494.71 394.99 532.38 396.81 514.91 361.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513.67 363.51 500.75 339.67 461.43 339.67 493.46 397.36 531.14 399.17 513.67 363.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.39,349.67a2,2,0,1,0-.31-2.77A2,2,0,0,0,481.39,349.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.71,381.39V416a26.9,26.9,0,0,1-8.12,19.62h0a19.89,19.89,0,0,1-22.32,3.83l-80.09-40.66,7.85-30.6,64.43,24.33.66-11.54Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.78,371.43l-6.22-7.72a21.58,21.58,0,0,0-16.8-8h-5.43l-3.7,4.17S492,361,491.06,364.29l0,1,0,.62,22.74,1.53s-19.34-.06-20.5,0-5.4-.32-5.31,1.95c.07,1.87,2.27,3.34,5.62,3.83,1.37.2,18.13,1.65,18.13,1.65l-18.45-.17c-2.06,0-1.8,3.31-.57,3.72,1,.33,24.59,7.22,24.59,7.22s-4,2.67-7.21,2.44-8.8-4.41-10-2.44-.93,3.13-.23,3.59,8.33,4.4,10.88,5.1,23.35,4,23.35,4l7.51,1.21Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.93,349s-4.11,1.44-2,6.72a45.12,45.12,0,0,0,8.34,13.21,4.83,4.83,0,0,0,1.64,4.73s-2.91.73-1.09,5.64a5.53,5.53,0,0,0,3.45,7.28s-1.45,4.19,3.83,6.19,10.37-1.46,10.37-1.46Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.27,368.49c3.73,1,7.84,1.81,11.29,3.12,1.14.43,2.27.45,3,1.41a2.59,2.59,0,0,1,.07,3.33,3.61,3.61,0,0,1-3,.61A53.25,53.25,0,0,1,475,373.75",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.76,374.72c3.73,1,7.84,1.81,11.3,3.12,1.13.44,2.26.46,3,1.41a2.6,2.6,0,0,1,.07,3.34,3.65,3.65,0,0,1-3,.61A53.41,53.41,0,0,1,476.52,380",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.88,381.14c3.74,1,7.84,1.81,11.3,3.12,1.14.43,2.26.46,3,1.41a2.6,2.6,0,0,1,.06,3.33,3.6,3.6,0,0,1-3,.61,54.11,54.11,0,0,1-11.58-3.2",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.25,373.88c.06-.15,2.7.77,6,1.69s6,1.5,6,1.67a33.18,33.18,0,0,1-12-3.36Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.56,379.39a70.29,70.29,0,0,1,6.83,1.94c3.76,1.1,6.84,1.89,6.81,2.06a48.64,48.64,0,0,1-13.64-4Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,386.46a37.07,37.07,0,0,1,6.42,1.3,37.94,37.94,0,0,1,6.28,1.87,35.79,35.79,0,0,1-6.42-1.3A36.83,36.83,0,0,1,477,386.46Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.16,367.72c.06-.16,3.37,1,7.53,2s7.6,1.71,7.57,1.88a8,8,0,0,1-2.29-.19,55.1,55.1,0,0,1-5.42-1.12,52.23,52.23,0,0,1-5.29-1.65A7.9,7.9,0,0,1,472.16,367.72Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.58,360.17a75.75,75.75,0,0,1,9.32-.34,74.87,74.87,0,0,1,9.34.24,76,76,0,0,1-9.33.34A74.77,74.77,0,0,1,509.58,360.17Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.72,413.36c-.1,0,.07-1.34-.07-3.48a22.92,22.92,0,0,0-.53-3.71,26.56,26.56,0,0,0-1.42-4.36,27,27,0,0,0-2.22-4,23.6,23.6,0,0,0-2.36-2.91c-1.48-1.56-2.56-2.34-2.5-2.42a3.37,3.37,0,0,1,.8.5,15.47,15.47,0,0,1,2,1.66,21.29,21.29,0,0,1,2.49,2.9,24.5,24.5,0,0,1,2.31,4.07,23.86,23.86,0,0,1,1.41,4.47,20.93,20.93,0,0,1,.43,3.79,16.32,16.32,0,0,1-.12,2.57A3,3,0,0,1,619.72,413.36Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.84,221.13c4.75-5.7,10.57-11.54,10.77-19,.11-3.95-1.32-8.38,1-11.54,2.06-2.75,6.15-3.19,8.46-5.73,3.09-3.39,1.76-8.74,2.82-13.2,1.15-4.86,5.31-8.6,10-10.32s9.82-1.69,14.78-1.12l4.65,102.22c-2.27-2.48-8.17-3.52-11.31-2.33s-6.09,3.14-9.44,3.41c-7.53.62-12.82-6.9-19.25-10.85-6.14-3.77-14.56-5-17.94-11.34C494.93,234.81,499.08,226.83,503.84,221.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.9,253.49a8,8,0,0,1-2.51-1,5.35,5.35,0,0,1-2-6.37c.48-1.47,1.82-2.52,3.4-3.54a9.25,9.25,0,0,0,2.29-2,4.8,4.8,0,0,0,1-3.16c-.12-2.3-1.31-4.3-2.06-6.4a9.51,9.51,0,0,1-.69-3.25,5.91,5.91,0,0,1,1-3.17,19,19,0,0,1,5.07-4.68,27.42,27.42,0,0,0,5.11-4.35,21.39,21.39,0,0,0,4.9-10.18,20.06,20.06,0,0,0,0-7.62,13.73,13.73,0,0,0-.53-2,2.34,2.34,0,0,0-.28-.67c-.1,0,.23,1,.45,2.73A21.8,21.8,0,0,1,527.76,215a27.09,27.09,0,0,1-5,4.18,19.65,19.65,0,0,0-5.33,4.93,6.8,6.8,0,0,0-1.11,3.65,10.43,10.43,0,0,0,.75,3.57c.82,2.19,2,4.15,2.07,6.13a4,4,0,0,1-.76,2.64,8.49,8.49,0,0,1-2.07,1.84,16.67,16.67,0,0,0-2.18,1.72,6,6,0,0,0-1.19,6.67,5.7,5.7,0,0,0,2.26,2.46,5.43,5.43,0,0,0,2,.72A1.65,1.65,0,0,0,517.9,253.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.16,276.2l.32-17.15s-17-2.52-21-24.63c-1.95-11-1.72-29.08-1-43.87.6-13.31,14.7-26.85,28-25.68l43.13,7.41,0,7.16-1.19,97.5a24.11,24.11,0,0,1-24.1,23.82h0A24.12,24.12,0,0,1,555.16,276.2Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.32,205.91a2.84,2.84,0,0,0,2.8,2.82,2.72,2.72,0,0,0,2.88-2.61,2.84,2.84,0,0,0-2.79-2.82A2.72,2.72,0,0,0,540.32,205.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.57,199.89c.36.36,2.48-1.27,5.54-1.32s5.33,1.45,5.66,1.06c.16-.16-.21-.83-1.2-1.52A7.85,7.85,0,0,0,543,196.8a7.43,7.43,0,0,0-4.4,1.51C537.7,199.05,537.39,199.72,537.57,199.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.41,205.11a2.84,2.84,0,0,0,2.8,2.82,2.71,2.71,0,0,0,2.88-2.61,2.84,2.84,0,0,0-2.79-2.82A2.72,2.72,0,0,0,568.41,205.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.65,199.92c.36.37,2.49-1.27,5.55-1.31s5.33,1.44,5.65,1.06c.16-.17-.21-.83-1.2-1.52a7.67,7.67,0,0,0-4.53-1.31,7.5,7.5,0,0,0-4.41,1.5C567.79,199.08,567.48,199.76,567.65,199.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557,222.81c0-.18-1.89-.47-5-.81-.79-.07-1.53-.21-1.67-.74a4,4,0,0,1,.48-2.32c.7-1.91,1.44-3.9,2.21-6,3-8.53,5.25-15.54,4.91-15.66s-3.1,6.7-6.16,15.22l-2.11,6a4.51,4.51,0,0,0-.35,3.07,2,2,0,0,0,1.31,1.12,5.16,5.16,0,0,0,1.33.16C555,223,556.94,223,557,222.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.48,259.05A56.36,56.36,0,0,0,585,250.6s-7.42,15.49-29.65,13.81Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.38,230.16a5.49,5.49,0,0,1,4.9-2.14,5,5,0,0,1,3.51,1.81,3.19,3.19,0,0,1,.31,3.64,3.71,3.71,0,0,1-4,1.08,11.38,11.38,0,0,1-4-2.26,3.58,3.58,0,0,1-.89-.89,1,1,0,0,1,0-1.14",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566,224.77c-.49,0-.44,3.3-3.24,5.7s-6.34,2.11-6.36,2.57c0,.21.8.63,2.29.65a8.3,8.3,0,0,0,5.31-2A7.21,7.21,0,0,0,566.5,227C566.61,225.56,566.22,224.74,566,224.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.65,188c.32.82,3.36.37,7,.74s6.52,1.3,7,.54c.21-.36-.31-1.13-1.5-1.91a11.48,11.48,0,0,0-5.19-1.72,11.7,11.7,0,0,0-5.43.73C567.16,186.89,566.51,187.55,566.65,188Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.54,191c.55.69,2.64-.07,5.18-.15s4.68.38,5.17-.35c.21-.36-.14-1-1.09-1.69a7.16,7.16,0,0,0-4.24-1.06,7.08,7.08,0,0,0-4.1,1.47C538.57,190,538.29,190.68,538.54,191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.28,198.4c-7.3-8.94-28-25-38.14-29.44-1.61-.72-3.12-2.21-4.11-2.21a31.63,31.63,0,0,0-5.95,4c-5.38,4.71-9.65,15.79-11.72,22.64-3-8.52-2-20.77,3.9-27.59s12.22-10.59,21.24-11,15.81,1.58,23.5,6.32c3,1.87,14,11,17.11,16.27Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.47,155.23c-1.5.16,8.56-8.09,14.84-9.22a25.23,25.23,0,0,1,18.25,3.82c3.58,2.4,6.58,5.75,10.55,7.44,3,1.29,6.39,1.5,9.54,2.44A22.17,22.17,0,0,1,623,178.81c.27,3.68-.4,7.36-.46,11.05s.62,7.62,3.12,10.34c2.16,2.35,5.34,3.44,8,5.14A20,20,0,0,1,642.59,225c-.66,4-2.57,8.18-1.17,12,.91,2.53,3.11,4.35,4.59,6.6a13.4,13.4,0,0,1-.49,15.07c-3.75.41-6.71,3.23-9.63,5.63s-6.65,4.61-10.27,3.54c-4.7-1.38-6.94-7.67-11.79-8.36s-8.22,4.37-12.71,6.07c-5.12,1.93-11.1-1-14.2-5.5s-3.84-10.21-3.95-15.69c-.14-6.88.74-14.14,4.81-19.68,2.92-4,7.56-7.39,7.63-12.32.06-4.73-4.25-8.47-5-13.14-.63-4.1,1.57-8,3.27-11.8s4.85-9.37,2.46-12.76C596.17,174.63,579.83,152.41,554.47,155.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.47,158.94c-.07-.08-.78.36-1.37,1.52a5.69,5.69,0,0,0,3.68,8.11c1.27.32,2.06.07,2,0s-.76-.16-1.84-.59a5.57,5.57,0,0,1-3.28-7.24C552.08,159.62,552.58,159,552.47,158.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.26,168.4c.07.24,1.54,0,3-1.15s2-2.47,1.82-2.59-1.11.87-2.39,1.86S546.17,168.15,546.26,168.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.9,162.6c0-.26-1.35-.22-2.84-.63s-2.62-1.07-2.79-.87.82,1.31,2.55,1.77S561,162.84,560.9,162.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.74,158.54c0-.26-1.33-.27-2.88,0s-2.78.63-2.74.88,1.33.27,2.88,0S560.78,158.79,560.74,158.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.75,159.91c0,.25.5.5,1.16.55s1.2-.12,1.22-.38-.5-.5-1.16-.55S545.77,159.65,545.75,159.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.58,162.44c0,.26.76.47,1.7.47s1.71-.21,1.71-.47-.77-.46-1.71-.46S545.58,162.19,545.58,162.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.63,177.36c-.19.2,2.13,2.58,4.47,5.91s3.83,6.3,4.08,6.19-.9-3.31-3.32-6.72S584.78,177.17,584.63,177.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.82,170.76c-.21.18,2.49,3.52,5.25,8s4.56,8.4,4.81,8.3-1.19-4.22-4-8.79S584,170.6,583.82,170.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.6,202.36s.2-.17.53-.56a7,7,0,0,0,1-2,9.07,9.07,0,0,0-1.23-7.92c-2-3-6.6-4.75-11.13-3.48-2.32.56-4.26,2.19-6.24,3.5a10.09,10.09,0,0,1-3.19,1.53,4,4,0,0,1-3.26-.68,5.53,5.53,0,0,1-1.85-3,9.78,9.78,0,0,1-.18-3.54c.28-2.36.85-4.73.91-7,.25-4.56-.89-8.82-3.15-11.54a11.08,11.08,0,0,0-6.92-4.13,7.75,7.75,0,0,0-2.22,0,2.53,2.53,0,0,0-.75.2,14.77,14.77,0,0,1,2.91.16,11.08,11.08,0,0,1,6.47,4.18c2.06,2.62,3.09,6.68,2.8,11.09-.08,2.23-.64,4.48-1,7s.06,5.49,2.36,7.32a4.82,4.82,0,0,0,4,.85,10.81,10.81,0,0,0,3.5-1.67c2.07-1.39,3.85-2.91,6-3.44,4.19-1.22,8.5.35,10.37,3a8.87,8.87,0,0,1,1.41,7.43A12.22,12.22,0,0,1,643.6,202.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.35,204a7.22,7.22,0,0,1,.75-.05,2.41,2.41,0,0,1,1.76,1,2.31,2.31,0,0,1,0,3,3.47,3.47,0,0,1-3.91.84,5.19,5.19,0,0,1-2.76-4.23,13.93,13.93,0,0,1,1.14-6.13c.79-2,1.9-4.28,3.87-5.51a5.43,5.43,0,0,1,3.36-.71,22.93,22.93,0,0,1,3.72.83,11.22,11.22,0,0,0,4,.54,5.2,5.2,0,0,0,3.57-1.89,9.52,9.52,0,0,0,1.67-7.12c-.25-2.31-.78-4.41-.82-6.39a13.16,13.16,0,0,1,1.08-5.35,14.34,14.34,0,0,1,5-6.14c1.58-1.07,2.61-1.4,2.58-1.49a2.56,2.56,0,0,0-.76.2,11.74,11.74,0,0,0-2,1,14.19,14.19,0,0,0-5.4,6.19,13.43,13.43,0,0,0-1.24,5.62c0,2.09.51,4.24.73,6.46a8.71,8.71,0,0,1-1.52,6.46,4.28,4.28,0,0,1-3,1.55,10.57,10.57,0,0,1-3.67-.51,22.63,22.63,0,0,0-3.89-.86,6.34,6.34,0,0,0-3.91.85c-2.29,1.47-3.4,3.86-4.2,6a14.42,14.42,0,0,0-1.1,6.52,5.83,5.83,0,0,0,3.26,4.73,4,4,0,0,0,4.58-1.12,2.66,2.66,0,0,0,.57-2,3,3,0,0,0-.7-1.55,2.57,2.57,0,0,0-2-1A1.32,1.32,0,0,0,507.35,204Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653,233.17a4,4,0,0,1-.7.12,2,2,0,0,1-1.59-1,1.74,1.74,0,0,1-.25-1.31,2,2,0,0,1,1-1.24,3.06,3.06,0,0,1,3.72.58,6.85,6.85,0,0,1,1.77,4.64,4.73,4.73,0,0,1-.69,2.64A3.87,3.87,0,0,1,654,239.2a5.48,5.48,0,0,1-5.68-1.82,10.21,10.21,0,0,1-2.19-6.51,52.23,52.23,0,0,1,.68-7.22,19.19,19.19,0,0,0-.17-6.94,11.91,11.91,0,0,0-3.16-5.46,16.92,16.92,0,0,0-4.46-3.17,31,31,0,0,0-7.46-2.41,14.71,14.71,0,0,0-2.83-.45,19.82,19.82,0,0,0,2.75.8,35.67,35.67,0,0,1,7.24,2.64,17,17,0,0,1,4.21,3.12,11.2,11.2,0,0,1,2.88,5.13,18.59,18.59,0,0,1,.1,6.63,51.6,51.6,0,0,0-.71,7.35A11.12,11.12,0,0,0,647.6,238a6.62,6.62,0,0,0,3.07,2,6.36,6.36,0,0,0,3.54,0,4.81,4.81,0,0,0,2.74-2,5.62,5.62,0,0,0,.77-3.09,7.4,7.4,0,0,0-2.09-5.11,3.63,3.63,0,0,0-4.44-.54,2.41,2.41,0,0,0-1.14,1.59,2.31,2.31,0,0,0,2.27,2.62A1.05,1.05,0,0,0,653,233.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.25,148.62a4,4,0,0,0,.29-.7,2.93,2.93,0,0,1,1.49-1.41,4.92,4.92,0,0,1,3.25-.19,3.54,3.54,0,0,1,2.73,2.93c.58,3.16-3.09,7.15-7.44,6.38a12.12,12.12,0,0,1-6.07-2.93,34.7,34.7,0,0,1-5-5.61,34.35,34.35,0,0,0-5.13-5.73,12.55,12.55,0,0,0-6.58-3A9.8,9.8,0,0,0,562.5,140a13.35,13.35,0,0,0-4,4.1,21.27,21.27,0,0,0-2.69,7.68c-.15.94-.24,1.68-.28,2.18a2.47,2.47,0,0,0,0,.78,29.39,29.39,0,0,0,.65-2.9,22.49,22.49,0,0,1,2.88-7.39,12.93,12.93,0,0,1,3.82-3.8,9.09,9.09,0,0,1,5.84-1.45,11.67,11.67,0,0,1,6.08,2.86,33.8,33.8,0,0,1,5,5.59,34.77,34.77,0,0,0,5.1,5.75,12.93,12.93,0,0,0,6.55,3.08,7.35,7.35,0,0,0,6.21-2,6.08,6.08,0,0,0,2-5.33,4,4,0,0,0-1.22-2.28,4.54,4.54,0,0,0-2-1,5.16,5.16,0,0,0-3.54.36,3.07,3.07,0,0,0-1.51,1.67A1.75,1.75,0,0,0,591.25,148.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.92,154.71s.07-.11.15-.35a3.44,3.44,0,0,1,.47-1,6.61,6.61,0,0,1,3.32-2.41,17.67,17.67,0,0,1,6.55-.93,15.67,15.67,0,0,1,4.08.62,13.28,13.28,0,0,1,4,2.31,31.13,31.13,0,0,1,7,8,18,18,0,0,1,1.29,2.6,7.79,7.79,0,0,0,1.63,2.74,12.77,12.77,0,0,0,5.61,3.37,23.42,23.42,0,0,0,3.29.67,13.44,13.44,0,0,1,3.11,1.06,13,13,0,0,1,5.14,4.3,11.08,11.08,0,0,1,1.87,6.62,46.16,46.16,0,0,1-.88,7.34,23.86,23.86,0,0,0-.34,7.59,10.91,10.91,0,0,0,3.57,6.51c3.67,3.32,8.27,4.66,11.49,7.5a11.33,11.33,0,0,1,3.6,4.91,7.35,7.35,0,0,1-.48,5.58c-.78,1.73-1.87,3.28-2.63,5A8.36,8.36,0,0,0,625,232a7.06,7.06,0,0,0,2.93,3.85,33.19,33.19,0,0,1,3.33,2.52,7.12,7.12,0,0,1,2,6,22.72,22.72,0,0,1-.81,4.15,10.86,10.86,0,0,0-.37,1.44,1.4,1.4,0,0,0,.16-.35c.1-.23.23-.58.39-1a20.31,20.31,0,0,0,1-4.17,9.43,9.43,0,0,0-.17-3.13A6.77,6.77,0,0,0,631.6,238a33.83,33.83,0,0,0-3.33-2.62,6.39,6.39,0,0,1-2.65-3.52,7.66,7.66,0,0,1,.79-4.82c.73-1.6,1.84-3.14,2.68-5a8.19,8.19,0,0,0,.56-6.15,12.23,12.23,0,0,0-3.82-5.31c-3.4-3-8-4.37-11.44-7.52a10,10,0,0,1-3.27-6,22.82,22.82,0,0,1,.35-7.29,46.1,46.1,0,0,0,.88-7.5,11.85,11.85,0,0,0-2.05-7.12,13.6,13.6,0,0,0-5.5-4.59,14.65,14.65,0,0,0-3.31-1.11,24.46,24.46,0,0,1-3.22-.64,11.88,11.88,0,0,1-5.26-3.1,6.83,6.83,0,0,1-1.49-2.48,18.59,18.59,0,0,0-1.37-2.71,31.31,31.31,0,0,0-7.29-8.1,13.41,13.41,0,0,0-4.2-2.35,16.16,16.16,0,0,0-4.23-.58,17.66,17.66,0,0,0-6.7,1.11,6.53,6.53,0,0,0-3.35,2.65,2.92,2.92,0,0,0-.4,1.05C563.92,154.59,563.9,154.71,563.92,154.71Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-259"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M694,453.57c0,.14-139.69.26-312,.26s-312-.12-312-.26,139.66-.26,312-.26S694,453.42,694,453.57Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-259"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.79,364.2a.86.86,0,0,0-.12-.27l-.41-.77c-.38-.66-1-1.62-1.8-2.81a30.38,30.38,0,0,0-8.89-8.4,21.9,21.9,0,0,0-8-2.93,19.85,19.85,0,0,0-9.69,1,15.74,15.74,0,0,0-8.29,6.79c-1.9,3.32-2.52,7.23-3.63,11a19.89,19.89,0,0,1-2.32,5.23,15.75,15.75,0,0,1-3.93,3.88c-1.48,1.09-3,2.08-4.44,3.22a19.55,19.55,0,0,0-3.61,3.91,24.07,24.07,0,0,0-3.69,9,31.5,31.5,0,0,0-.49,8.47,64,64,0,0,0,2.17,12.07c.36,1.4.67,2.47.89,3.2a7.83,7.83,0,0,0,.36,1.11,8.24,8.24,0,0,0-.23-1.14c-.19-.8-.45-1.88-.77-3.24a69.68,69.68,0,0,1-1.95-12,31.9,31.9,0,0,1,.57-8.34,23.62,23.62,0,0,1,3.65-8.78,18.64,18.64,0,0,1,3.51-3.77c1.37-1.11,2.91-2.08,4.42-3.19a16.38,16.38,0,0,0,4.1-4,20.56,20.56,0,0,0,2.41-5.41c1.12-3.79,1.73-7.64,3.56-10.82a15.1,15.1,0,0,1,7.93-6.54,19.25,19.25,0,0,1,9.39-1,21.73,21.73,0,0,1,7.82,2.78,31.12,31.12,0,0,1,8.92,8.15c.86,1.15,1.48,2.09,1.89,2.72A8,8,0,0,0,327.79,364.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,377.88c1-.95,1.53-.29,2.91,0a8.65,8.65,0,0,1,3.73,1.86,15.71,15.71,0,0,1,5.09,16.49,12.26,12.26,0,0,1-11.26-18.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.2,358.67c.52-1.31,1.26-.92,2.61-1.29a8.66,8.66,0,0,1,4.17.07,15.73,15.73,0,0,1,11.69,12.7,12.26,12.26,0,0,1-18.09-11.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.69,403.89A14.14,14.14,0,0,1,291.94,405a17.49,17.49,0,0,1-11.54,4.55,17.85,17.85,0,0,1-11.62-4.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.16,384.47a14.34,14.34,0,0,1-14.49-17.12,12.88,12.88,0,0,1,15,17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,361.64a14.35,14.35,0,0,1-19.35-11.33,12.88,12.88,0,0,1,19.76,11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,354.18a14.35,14.35,0,0,1,19.35,11.33,12.88,12.88,0,0,1-19.76-11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.93,350.17a14.35,14.35,0,0,1-7.63-21.09,12.87,12.87,0,0,1,8.13,21.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.15,350.89a14.34,14.34,0,0,1,11.71-19.12,12.87,12.87,0,0,1-11.43,19.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "252.81 453.75 244.7 402.87 306.83 403.62 300.7 453.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.62,393.57a10.56,10.56,0,0,0,10.31.87,11.16,11.16,0,0,0,5.64-8.91,11.91,11.91,0,0,0-17.14,7.13",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,404.53a10.61,10.61,0,0,0,10.31.87,11.16,11.16,0,0,0,5.64-8.91,11.91,11.91,0,0,0-17.14,7.13",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.07,380.06a10.62,10.62,0,0,0,8.14,6.4,11.19,11.19,0,0,0,9.61-4.35,12.69,12.69,0,0,0-8.31-6.1,12.55,12.55,0,0,0-9.93,2.64",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.44,392.74a10.57,10.57,0,0,0-9.27,4.59,11.15,11.15,0,0,0-.22,10.54,11.92,11.92,0,0,0,11-15",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.45,412.76a10.6,10.6,0,0,0,.24,10.35,11.17,11.17,0,0,0,9.47,4.64,12.62,12.62,0,0,0-.59-10.29c-1.63-3-4.57-4.43-8.26-5.27",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,415.12a7.57,7.57,0,0,0-2.46-1.57,11,11,0,0,0-3.37-.59,41.66,41.66,0,0,0-4.58.27,13.32,13.32,0,0,1-5.65-.48,8.67,8.67,0,0,1-4.66-4.5,25.62,25.62,0,0,1-2-6.88,19.8,19.8,0,0,0-2.4-7.05,25.09,25.09,0,0,0-5.25-5.34,25.28,25.28,0,0,1-5-5.1,16.85,16.85,0,0,1-2.5-11.69,16.5,16.5,0,0,1,3.05-7.52A13.38,13.38,0,0,1,295.6,363a3.17,3.17,0,0,1,.59-.5,4.34,4.34,0,0,1-.49.6,15.35,15.35,0,0,0-1.38,1.7,16.81,16.81,0,0,0-2.79,7.42,16.48,16.48,0,0,0,2.55,11.28,25.09,25.09,0,0,0,4.93,5,24.88,24.88,0,0,1,5.4,5.48,20,20,0,0,1,2.47,7.29A25.76,25.76,0,0,0,308.8,408a8.16,8.16,0,0,0,4.3,4.26,13.09,13.09,0,0,0,5.42.53,36,36,0,0,1,4.63-.17,10.37,10.37,0,0,1,3.45.72,5.89,5.89,0,0,1,1.87,1.21,3,3,0,0,1,.38.43C328.93,415.06,329,415.11,329,415.12Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,415.12a7.57,7.57,0,0,0-2.46-1.57,11,11,0,0,0-3.37-.59,41.66,41.66,0,0,0-4.58.27,13.32,13.32,0,0,1-5.65-.48,8.67,8.67,0,0,1-4.66-4.5,25.62,25.62,0,0,1-2-6.88,19.8,19.8,0,0,0-2.4-7.05,25.09,25.09,0,0,0-5.25-5.34,25.28,25.28,0,0,1-5-5.1,16.85,16.85,0,0,1-2.5-11.69,16.5,16.5,0,0,1,3.05-7.52A13.38,13.38,0,0,1,295.6,363a3.17,3.17,0,0,1,.59-.5,4.34,4.34,0,0,1-.49.6,15.35,15.35,0,0,0-1.38,1.7,16.81,16.81,0,0,0-2.79,7.42,16.48,16.48,0,0,0,2.55,11.28,25.09,25.09,0,0,0,4.93,5,24.88,24.88,0,0,1,5.4,5.48,20,20,0,0,1,2.47,7.29A25.76,25.76,0,0,0,308.8,408a8.16,8.16,0,0,0,4.3,4.26,13.09,13.09,0,0,0,5.42.53,36,36,0,0,1,4.63-.17,10.37,10.37,0,0,1,3.45.72,5.89,5.89,0,0,1,1.87,1.21,3,3,0,0,1,.38.43C328.93,415.06,329,415.11,329,415.12Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,420.33a15.72,15.72,0,0,0-21.27-15.48,26.23,26.23,0,0,0,20.71,15.29",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.26,422.5c-3,3.33-2.84,8.7-.66,12.65s5.91,6.77,9.66,9.28a20.43,20.43,0,0,0-8.79-23.14",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,406.85A18.14,18.14,0,0,0,241.59,423c-1.18-4.88-3.14-9.8-6.91-13.12s-9.72-4.54-13.89-1.76",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.88,401.87c-.76-4.44-5.14-7.67-9.63-8.08s-8.93,1.49-12.53,4.21a16.28,16.28,0,0,0,22.21,2.19",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.74,439.68c-4.27,3.64-5.33,10.13-3.56,15.45s5.92,9.57,10.59,12.68c1.79-5.28,2.92-10.93,2-16.42s-4.25-10.8-9.36-13",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.19,389.4A13.12,13.12,0,0,1,241,388.19a11.33,11.33,0,0,1-20.45.52",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.42,376.58a17,17,0,0,1-21.73-13.32,39.14,39.14,0,0,1,10.26.15,16.65,16.65,0,0,1,9.09,4.48,9,9,0,0,1,2.38,8.69",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.28,373.27a13.92,13.92,0,0,1-.09-21.5,29.17,29.17,0,0,1,6.09,13,10.88,10.88,0,0,1-.05,5.38,4.93,4.93,0,0,1-3.76,3.51",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.37,420.33a15.72,15.72,0,0,0-21.27-15.48,26.23,26.23,0,0,0,20.71,15.29"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M206.26,422.5c-3,3.33-2.84,8.7-.66,12.65s5.91,6.77,9.66,9.28a20.43,20.43,0,0,0-8.79-23.14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221,406.85A18.14,18.14,0,0,0,241.59,423c-1.18-4.88-3.14-9.8-6.91-13.12s-9.72-4.54-13.89-1.76"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220.88,401.87c-.76-4.44-5.14-7.67-9.63-8.08s-8.93,1.49-12.53,4.21a16.28,16.28,0,0,0,22.21,2.19"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.74,439.68c-4.27,3.64-5.33,10.13-3.56,15.45s5.92,9.57,10.59,12.68c1.79-5.28,2.92-10.93,2-16.42s-4.25-10.8-9.36-13"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M220.19,389.4A13.12,13.12,0,0,1,241,388.19a11.33,11.33,0,0,1-20.45.52"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.42,376.58a17,17,0,0,1-21.73-13.32,39.14,39.14,0,0,1,10.26.15,16.65,16.65,0,0,1,9.09,4.48,9,9,0,0,1,2.38,8.69"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.28,373.27a13.92,13.92,0,0,1-.09-21.5,29.17,29.17,0,0,1,6.09,13,10.88,10.88,0,0,1-.05,5.38,4.93,4.93,0,0,1-3.76,3.51"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M252.32,404.5s0-.12,0-.35,0-.6.06-1c.06-.9.14-2.23.17-3.93a35.19,35.19,0,0,0-2.31-14.12,21.5,21.5,0,0,0-5.68-8,15.12,15.12,0,0,0-10.33-3.81,12.93,12.93,0,0,0-5.82,1.46,11.7,11.7,0,0,0-4.51,4.3c-2.25,3.72-2.81,8.38-2.61,13s.82,9.21.31,13.66a20.8,20.8,0,0,1-1.7,6.33,13.3,13.3,0,0,1-3.82,5,19.16,19.16,0,0,1-5.32,2.72,26.8,26.8,0,0,0-5,2.28,18.13,18.13,0,0,0-6.59,7.18,17.4,17.4,0,0,0-1.9,7.85,18.45,18.45,0,0,0,1,6.07,22.92,22.92,0,0,0,2.35,4.72s-.08-.08-.22-.26-.36-.46-.6-.84a16.45,16.45,0,0,1-1.77-3.53,18.36,18.36,0,0,1-1.13-6.16,17.63,17.63,0,0,1,1.85-8.07,18.73,18.73,0,0,1,6.72-7.44c3.07-2,7.13-2.55,10.25-5s4.77-6.65,5.25-10.93-.16-8.87-.32-13.56.36-9.46,2.72-13.34a12.27,12.27,0,0,1,4.77-4.53,13.59,13.59,0,0,1,6.11-1.51,15.73,15.73,0,0,1,10.71,4,21.93,21.93,0,0,1,5.75,8.23,29.75,29.75,0,0,1,2,8.05,43.25,43.25,0,0,1,.17,6.26c-.07,1.71-.2,3-.3,3.93,0,.42-.09.75-.13,1A1.48,1.48,0,0,1,252.32,404.5Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M252.32,404.5s0-.12,0-.35,0-.6.06-1c.06-.9.14-2.23.17-3.93a35.19,35.19,0,0,0-2.31-14.12,21.5,21.5,0,0,0-5.68-8,15.12,15.12,0,0,0-10.33-3.81,12.93,12.93,0,0,0-5.82,1.46,11.7,11.7,0,0,0-4.51,4.3c-2.25,3.72-2.81,8.38-2.61,13s.82,9.21.31,13.66a20.8,20.8,0,0,1-1.7,6.33,13.3,13.3,0,0,1-3.82,5,19.16,19.16,0,0,1-5.32,2.72,26.8,26.8,0,0,0-5,2.28,18.13,18.13,0,0,0-6.59,7.18,17.4,17.4,0,0,0-1.9,7.85,18.45,18.45,0,0,0,1,6.07,22.92,22.92,0,0,0,2.35,4.72s-.08-.08-.22-.26-.36-.46-.6-.84a16.45,16.45,0,0,1-1.77-3.53,18.36,18.36,0,0,1-1.13-6.16,17.63,17.63,0,0,1,1.85-8.07,18.73,18.73,0,0,1,6.72-7.44c3.07-2,7.13-2.55,10.25-5s4.77-6.65,5.25-10.93-.16-8.87-.32-13.56.36-9.46,2.72-13.34a12.27,12.27,0,0,1,4.77-4.53,13.59,13.59,0,0,1,6.11-1.51,15.73,15.73,0,0,1,10.71,4,21.93,21.93,0,0,1,5.75,8.23,29.75,29.75,0,0,1,2,8.05,43.25,43.25,0,0,1,.17,6.26c-.07,1.71-.2,3-.3,3.93,0,.42-.09.75-.13,1A1.48,1.48,0,0,1,252.32,404.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M342.77,393.4a13.16,13.16,0,0,0,.93-4.55,11.46,11.46,0,0,0-1.21-5.26,11,11,0,0,0-5.07-4.89,11.07,11.07,0,0,0-4-1.08,12.83,12.83,0,0,0-4.46.53c-3.05.8-6.06,2.53-9.66,3.24a11.33,11.33,0,0,1-5.6-.14,8.4,8.4,0,0,1-4.56-3.64c-2.17-3.36-2.78-7.59-5.4-10.69a10.72,10.72,0,0,0-4.91-3.21,13.82,13.82,0,0,0-5.73-.58,14.72,14.72,0,0,0-9.54,5,22.54,22.54,0,0,0-4.73,8.76,26.38,26.38,0,0,0-1.06,8.68,97.38,97.38,0,0,0,1.61,12.69c.25,1.45.45,2.6.6,3.44.05.36.1.65.13.9s0,.3,0,.31a1.31,1.31,0,0,1-.09-.3c-.05-.24-.12-.53-.2-.89-.17-.83-.41-2-.71-3.41a86.1,86.1,0,0,1-1.83-12.73,26.46,26.46,0,0,1,1-8.84,22.86,22.86,0,0,1,4.81-9,17.18,17.18,0,0,1,4.36-3.49,14.37,14.37,0,0,1,5.57-1.71,14.18,14.18,0,0,1,6,.6,11.26,11.26,0,0,1,5.21,3.4c2.78,3.33,3.37,7.58,5.45,10.77a7.76,7.76,0,0,0,4.2,3.39,10.74,10.74,0,0,0,5.28.14c3.47-.66,6.5-2.37,9.63-3.17a13.33,13.33,0,0,1,4.65-.51,11.67,11.67,0,0,1,4.16,1.17,11.36,11.36,0,0,1,5.2,5.15,11.54,11.54,0,0,1,1.13,5.43,10.67,10.67,0,0,1-.67,3.44A5.52,5.52,0,0,1,342.77,393.4Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.44,370.86a12.07,12.07,0,0,0,11.08.72,11.16,11.16,0,0,0,5.64-8.91A11.92,11.92,0,0,0,306,369.8",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.21,381.54a12.09,12.09,0,0,0,5.15,9.84,11.16,11.16,0,0,0,10.54.18,11.91,11.91,0,0,0-15-10.93",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.65,379.17a12.06,12.06,0,0,0,11.09-.46,11.16,11.16,0,0,0,4.66-9.46,12.7,12.7,0,0,0-10.29.57,12.55,12.55,0,0,0-6,8.35",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.28,363.78c-3-2.57-5-7.08-4.4-10.46a11.2,11.2,0,0,1,6.84-8A11.92,11.92,0,0,1,290,363.78",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.51,349.15a1.17,1.17,0,0,1,.12-.27c.11-.21.24-.46.41-.76a33,33,0,0,1,1.8-2.81,30,30,0,0,1,8.89-8.4,21.78,21.78,0,0,1,8-2.93,19.72,19.72,0,0,1,9.69,1,15.66,15.66,0,0,1,8.29,6.79c1.91,3.32,2.52,7.23,3.64,11a19.81,19.81,0,0,0,2.31,5.22,15.45,15.45,0,0,0,3.94,3.88c1.48,1.1,3,2.08,4.44,3.23a19,19,0,0,1,3.6,3.91,24.05,24.05,0,0,1,3.7,9,32.39,32.39,0,0,1,.49,8.48,64.73,64.73,0,0,1-2.17,12.06c-.37,1.4-.68,2.48-.89,3.21a9.93,9.93,0,0,1-.36,1.11,5.6,5.6,0,0,1,.23-1.14c.19-.8.44-1.88.77-3.24a69.81,69.81,0,0,0,1.94-12,31.9,31.9,0,0,0-.56-8.34,23.72,23.72,0,0,0-3.66-8.78,18.54,18.54,0,0,0-3.5-3.76c-1.37-1.11-2.91-2.09-4.42-3.19a16.41,16.41,0,0,1-4.11-4,20.68,20.68,0,0,1-2.4-5.41c-1.13-3.79-1.74-7.64-3.56-10.83a15.14,15.14,0,0,0-7.94-6.53,19.23,19.23,0,0,0-9.39-1.05,21.43,21.43,0,0,0-7.81,2.79,30.84,30.84,0,0,0-8.92,8.15c-.86,1.15-1.48,2.08-1.9,2.72A7.63,7.63,0,0,1,209.51,349.15Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.31,362.84c-1-1-1.53-.29-2.91,0a8.65,8.65,0,0,0-3.73,1.86,15.71,15.71,0,0,0-5.09,16.49,12.26,12.26,0,0,0,11.26-18.42",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.09,343.62c-.51-1.3-1.25-.92-2.61-1.28a8.49,8.49,0,0,0-4.16.07,15.71,15.71,0,0,0-11.7,12.7,12.26,12.26,0,0,0,18.09-11.79",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.61,388.84a14.16,14.16,0,0,0-22.26,1.09,17.51,17.51,0,0,0,11.54,4.55,17.93,17.93,0,0,0,11.63-4.7",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.14,369.42a14.35,14.35,0,0,0,14.49-17.11,12.88,12.88,0,0,0-15,17",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.28,346.59a14.33,14.33,0,0,0,19.35-11.33,12.87,12.87,0,0,0-19.75,11",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.3,339.14A14.33,14.33,0,0,0,225,350.47a12.87,12.87,0,0,0,19.75-11",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.36,335.12A14.33,14.33,0,0,0,246,314a12.87,12.87,0,0,0-8.13,21.12",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.15,335.85a14.34,14.34,0,0,0-11.71-19.12,12.87,12.87,0,0,0,11.42,19.53",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.91 447.85 248.67 453.75 307.13 453.75 311.11 447.85 243.91 447.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.83,447.8c0,.18-14.37.33-32.09.33s-32.08-.15-32.08-.33,14.36-.34,32.08-.34S309.83,447.61,309.83,447.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.26,425.6a2.55,2.55,0,0,1-.37.48,13.38,13.38,0,0,1-1.19,1.25,21.73,21.73,0,0,1-5.22,3.62,23.07,23.07,0,0,1-9.13,2.35,22,22,0,0,1-5.58-.47,32.72,32.72,0,0,1-5.69-1.89c-3.77-1.6-7.2-3.43-10.53-4.49a18.16,18.16,0,0,0-9.1-.88,11.84,11.84,0,0,0-5.58,2.59,22.89,22.89,0,0,0-1.59,1.66,2.13,2.13,0,0,1,.29-.53A8.16,8.16,0,0,1,250.7,428a11.56,11.56,0,0,1,5.66-2.87,18.24,18.24,0,0,1,9.37.76c3.42,1.05,6.89,2.88,10.61,4.46a32.23,32.23,0,0,0,5.57,1.86,21.64,21.64,0,0,0,5.42.5,23,23,0,0,0,8.94-2.16A27.53,27.53,0,0,0,303.26,425.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.84,421a2,2,0,0,1-.4.46,16,16,0,0,1-1.28,1.16,24.21,24.21,0,0,1-5.41,3.36,25.64,25.64,0,0,1-9.19,2.2,25.06,25.06,0,0,1-5.6-.38,38.23,38.23,0,0,1-5.78-1.63c-3.86-1.41-7.4-3-10.79-4a21.46,21.46,0,0,0-9.17-.83,13.78,13.78,0,0,0-5.79,2.21c-1.21.85-1.74,1.5-1.79,1.45s.1-.18.36-.48a9.36,9.36,0,0,1,1.28-1.18,13.37,13.37,0,0,1,5.86-2.47,21.41,21.41,0,0,1,9.42.7c3.45.93,7,2.54,10.85,3.92a36.74,36.74,0,0,0,5.67,1.62,25,25,0,0,0,5.45.41,26,26,0,0,0,9-2A31.74,31.74,0,0,0,303.84,421Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/Status.7416b85eb25ad7041adb374f89a1317e.svg";
export { ForwardRef as ReactComponent };